import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import * as html2pdf from "html2pdf.js";
import * as moment from "moment";
import { ToWords } from "to-words";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { QuickLoanService } from "../services/quickLoan.service";
declare var $: any;
declare class Digio {
  constructor(options: DigioOptions);
  init(): void;
  submit(id1: string, id2: string): void;
}
declare const digio: Digio;

interface DigioOptions {
  environment: string;
  redirect: boolean;
  mode: string;
  theme: {
    primaryColor: string;
    secondaryColor: string;
    fontUrl: string;
    fontFormat: string;
    fontFamily: string;
  };
}

@Component({
  selector: "app-sanction-conditions",
  templateUrl: "./sanction-conditions.component.html",
  styleUrls: ["./sanction-conditions.component.scss"],
})
export class SanctionConditionsComponent implements OnInit {
  @ViewChild("templateContainer", { static: false })
  templateContainer: ElementRef;
  showSpinner: boolean = false;
  isDisabled = true;
  Value: any = "Add";
  BtnValue: any = "Save";
  loading: boolean = false;
  SanctionConditionsDetails: any = [];
  SanctionConditionsData: any = [];
  stepEMI: any[] = [];
  stepEMIProposed: any[] = [];
  stepEMIApproved: any[] = [];
  stepEmiDataApproved: any;
  minLoanMaturityDate: any;
  Name: any = "Months";
  dropdownTemplateSanction = [];
  dropdownTemplateAgreement = [];
  selectedSanctionTemplateName: string = "";
  selectedSanctionTemplateId: any = null;
  emiIrrdataApproved: any;
  emiIrr: any;
  stepEmiData: any;
  stepEmiDataProposed: any;
  selectedScheme: any = {};
  LoanDetail: any = {};
  LoanDetailApproved: any = {};
  LenderApproved: any;
  isCalEMITableView: boolean = true;
  stepEmiForm: boolean = true;
  isFrequency: boolean = false;

  Tcoborrower1Details = {};
  Tcoborrower2Details = {};
  Tguaranter1Details? = {};
  Tguaranter2Details = {};
  TChargesBalance: any;
  TChargesDeduction: any;
  TsanctionLoanAmountObj: any;
  sanctionLoanAmountObj: any;
  LODDataDetail: any = [];

  VoucherId: any;
  LoanId: any;
  dvDetail: any;
  stepArr: any;
  authRevertStatus: any = "Authorized";
  voucherRemark: any = "";
  receiptList: any[] = [];
  deductionList: any[] = [];
  dataSource: any;
  Tenure_Name: any;
  applicationDetails: any;
  voucherModel: any = { Voucher: {}, Voucher_Detail: [] };
  totalCalculator: {
    totalCR: number;
    totalDR: number;
    totalCRTX: number;
    totalDRTX: number;
    totalCRInWord: string;
    totalDRInWord: string;
  };
  displayedCustomerDetailColumns: string[] = [];
  displayedColumnsEsign: string[] = [];
  dataSourceCustomerDetail: any = [];
  selectedEsignSanctionFile: any;
  row: any;

  pdfBlob: Blob;
  pdfBlobUrl: string;
  previewHtml: string;

  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  @Input() Revert_IsEdit: any;
  Headers: any = [];
  Id: any = 0;
  dialogreturn: any;
  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() isNew: boolean;
  @Input() Status: any;
  @Input() ProcessName: any;
  currentUser: any;
  dataSourceEsign: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  emiIrrProposed: any;
  cEIModel: any = {
    Asset_Cost: 0,
    IRR_Type: "Flat",
    EMI_Type: "Monthly",
    ProductId: "",
    IRR_CalculateBy: "ROI",
    Adv_Inst: 0,
  };
  contentTemplate: any;
  Header: any;
  PageId: any = null;
  Vehicle_Type: any;
  selectedEsignFile: any;
  text: any;
  DocModel: any = {};
  DocModelSanction: any = {};
  dataUrl: string;
  KeyFectoreLoanAmount: any;
  KeyFectoreIRR: any;
  AverageScore: any;
  LoanKeyFectoreScoreData: any;
  FrequenctDropDownList: any;
  customerList: any;
  adharList: any;
  DIDNo: any;
  templateDataLetter: any;
  IRR_CalculateByDropDownList: any;
  constructor(
    private _Route: Router,
    private activedRoute: ActivatedRoute,
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private LmsService: LmsService,
    private DecriptService: EncrDecrService,
    private dialog: DialogService,
    private _QuickLoanService: QuickLoanService,
    private _EncrDecrService: EncrDecrService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private lmsService: LmsService
  ) {
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.LoanId = decodeURIComponent(param.get("id"));
      this.VoucherId = this._EncrDecrService.decrypt(
        decodeURIComponent(param.get("vid"))
      );
      this.PageId = decodeURIComponent(param.get("page"));
    });
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.GetFrequenctDropDown();
    this.GetIRR_CalculateByDropDown();
    this.LmsService.LMS_GetLoanDetails({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((res: any) => {
      this.Vehicle_Type = res.Item6.length > 0 ? res.Item6[0].Vehicle_Type : "";
      this.dataSourceCustomerDetail = [];
      if (res.Item2.length > 0) {
        var customerList = [];
        var adharList = [];
        res.Item2.forEach((x) => {
          if (customerList.length < 4) {
            this.dataSourceCustomerDetail.push(x);
            if (this.loanSummary.IsReasonSendEsign) {
              customerList.push({
                identifier: x.Customer_Email == null ? x.PhoneNo.toString() : x.Customer_Email.toString(),
                name: x.Customer.toString(),
                sign_type: "AADHAAR",
                reason:
                  "Loan Ref(" +
                  this.loanSummary.ApplicationNo +
                  " - " +
                  x.CustomerType +
                  ")",
                signing_addons: [
                  {
                    type: "GEO_LOCATION",
                    perform_enrichment: true,
                  },
                ],
              });
            } else {
              customerList.push({
                identifier: x.Customer_Email == null ? x.PhoneNo.toString() : x.Customer_Email.toString(),
                name: x.Customer.toString(),
                sign_type: "AADHAAR",
                signing_addons: [
                  {
                    type: "GEO_LOCATION",
                    perform_enrichment: true,
                  },
                ],
              });
            }

            adharList.push({
              [x.PhoneNo]: {
                abort_on_fail: "true",
                max_attempt: 3,
                rules: [
                  {
                    operation: "AND",
                    conditions: [
                      {
                        field: "gender",
                        match_type: "exact",
                        value: x.GenderAge.split(",")[0][0],
                      },
                      {
                        field: "aadhaar",
                        match_type: "exact",
                        value: x.AADHAARNo?.slice(-4),
                      },
                    ],
                  },
                ],
              },
            });
          }
        });
        $("#totalCustomer").text(this.dataSourceCustomerDetail.length);
        console.log(
          "this.dataSourceCustomerDetail.length",
          this.dataSourceCustomerDetail.length
        );

        const flatData: { [key: string]: any } = {};

        adharList.forEach((entry) => {
          const key = Object.keys(entry)[0];
          flatData[key] = entry[key];
        });
        this.customerList = JSON.stringify(customerList);
        this.adharList = JSON.stringify(flatData);
        console.log("his.adharList", JSON.stringify(flatData));
        console.log("his.customerList", JSON.stringify(customerList));
      }

      if (res.Item9.length > 0) {
        this.dataSourceEsign = new MatTableDataSource(
          JSON.parse(JSON.stringify(res.Item9))
        );
        this.displayedColumnsEsign = ["Id", "Status", "UploadId", "Action"];
      } else {
        this.dataSourceEsign = null;
      }
    });
    this.GetSanctionConditions();
    this.getLoanAccount();
  }
  GetFrequenctDropDown() {
    this.MasterService.GetCommonMaster_FOR_DROPDOWN({
      Type: "EMI FREQUENCY",
    }).subscribe((res: any) => {
      console.log(res);
      this.FrequenctDropDownList = res;
    });
  }

  GetIRR_CalculateByDropDown() {
    this.MasterService.GetCommonMaster_FOR_DROPDOWN({
      Type: "IRR_CalculateBy",
    }).subscribe((res: any) => {
      console.log(res);
      this.IRR_CalculateByDropDownList = res;
    });
  }
  addSanctionConditions() {
    this.Id = 0;
    this.Header = "";
    this.SanctionConditionsDetails = [];
    this.initializeDetail();
    $("#SanctionConditions").modal("show");
    $("#SanctionConditions").css("z-index", "1050");
  }
  onCloseSanctionConditions() {
    $("#SanctionConditions").modal("hide");
  }
  initializeDetail() {
    this.SanctionConditionsDetails.push({
      Detail: "",
    });
  }
  addMoreData() {
    this.initializeDetail();
  }
  removeData(index: any) {
    this.SanctionConditionsDetails.splice(index, 1);
  }
  OnSaveSanctionConditions() {
    this.onCloseSanctionConditions();
    this.showSpinner = true;
    var Details = { Data: this.SanctionConditionsDetails };
    this._QuickLoanService
      .QuickLoan_Save_Sanction_Conditions({
        JSON: JSON.stringify(Details),
        Header: this.Header,
        Loan_Id: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        Id: this.Id,
      })
      .subscribe((response: any) => {
        if (response[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.GetSanctionConditions();
          this.QuickLoan_Save_PageProcess("Sanction Conditions");
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
        this.showSpinner = false;
      });
  }
  GetSanctionConditions() {
    this.Headers = [];
    this._QuickLoanService
      .QuickLoan_Get_Sanction_Conditions({ Loan_Id: this.loanSummary.LoanId })
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.SanctionConditionsData = response;
          this.SanctionConditionsData.forEach((obj: any) => {
            if (
              this.Headers &&
              this.Headers.find((result) => result.Id === obj.Id)
            ) {
              this.Headers.find(
                (result) => result.Id === obj.Id
              ).Condition.push({ Detail: obj.Detail });
            } else {
              this.Headers.push({
                Id: obj.Id,
                Header: obj.Particulars,
                IsCompleted: obj.Is_Completed,
                Condition: [{ Detail: obj.Detail }],
              });
            }
          });
        }
      });
  }
  QuickLoan_Save_PageProcess(PageType) {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: PageType,
        ProductId: this.loanSummary.ProductId,
        Loan_Id: this.loanSummary.LoanId,
        Process_Id: this.Processid,
        Page_Id: this.PageData.MM_Id,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => { });
  }
  OnEditSanctionConditions(vdData) {
    this.Header = "";
    this.SanctionConditionsDetails = [];
    this.BtnValue = "Edit";
    this.Id = vdData.Id;
    this.Header = vdData.Header;
    vdData.Condition.forEach((obj: any) => {
      this.SanctionConditionsDetails.push({
        Detail: obj.Detail,
      });
    });
    $("#SanctionConditions").modal("show");
    $("#SanctionConditions").css("z-index", "1050");
  }
  OnDeleteSanctionConditions(Id) {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Delete Sanction Conditions.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this._QuickLoanService
            .QuickLoan_Delete_Sanction_Conditions({
              Loan_Id: this.loanSummary.LoanId,
              Id: Id,
            })
            .subscribe((response: any) => {
              if (response[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
                this.GetSanctionConditions();
                this.QuickLoan_Save_PageProcess("Sanction Conditions");
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: response[0].MSG,
                  ...this.configSuccess,
                });
              }
            });
        }
      });
  }
  getLoanAccount() {
    this.stepEMI = [];
    this._QuickLoanService
      .QuickLoan_Get_Financial_Proposed_And_Sanction({
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        if (res.Item1.length > 0) {
          this.LoanDetail = res.Item1[0];
          if (res.Item3.length > 0) {
            this.LenderApproved = res.Item3[0];
            this.LenderApproved.Heading = "Lender Approval";
            if (
              this.LenderApproved.EMI_Type == "Daily" ||
              this.LenderApproved.EMI_Type == "Weekly" ||
              this.LenderApproved.EMI_Type == "Fortnightly" ||
              this.LenderApproved.EMI_Type == "ByWeekly" ||
              this.LenderApproved.EMI_Type == "FourthWeekly" ||
              this.LenderApproved.EMI_Type == "SingleEMI"
            ) {
              this.LenderApproved.Name = "Days";
              this.Name = "Days";
            } else {
              this.LenderApproved.Name = "Months";
              this.Name = "Months";
            }
          }
          this._QuickLoanService
            .QuickLoan_Get_LoanKeyFectoreScore({
              LoanId: this.loanSummary.LoanId,
            })
            .subscribe((resultKey: any) => {
              if (resultKey.length > 0) {
                this.LoanKeyFectoreScoreData = resultKey[0];
                this.AverageScore = resultKey[0].AverageScore;
                this.KeyFectoreLoanAmount = resultKey[0].LoanAmount;
                this.KeyFectoreIRR = resultKey[0].IRR;
                if (resultKey[0].LoanAmount > this.LoanDetail.NetFinance) {
                  this.KeyFectoreLoanAmount = this.LoanDetail.NetFinance;
                }
                if (resultKey[0].KeyFectoreIRR < this.LoanDetail.Case_IRR) {
                  this.KeyFectoreIRR = this.LoanDetail.Case_IRR;
                }
              }
            });

          setTimeout(() => { }, 100);

          this.cEIModel.ProcessingFee = this.LoanDetail.ProcessingFeePercentage;
          let dataProposed = {
            Disbursement_Amt: res.Item1[0].DisbursementAmt,
            Interest_Amt: res.Item1[0].InterestAmt,
            Agreement_Value: res.Item1[0].AgreementValue,
            LTV: res.Item1[0].LTV,
            ROI: res.Item1[0].Flat_Rate,
            EMI_Amt: res.Item1[0].Application_LoanEMIAmount,
            Case_IRR: res.Item1[0].Case_IRR,
            Disbursement_IRR: res.Item1[0].Disbursement_IRR,
            Margin: res.Item1[0].Margin,
          };
          this.emiIrrProposed = dataProposed;
          if (
            this.LoanDetail.EMI_Type == "Daily" ||
            this.LoanDetail.EMI_Type == "Weekly" ||
            this.LoanDetail.EMI_Type == "Fortnightly" ||
            this.LoanDetail.EMI_Type == "ByWeekly" ||
            this.LoanDetail.EMI_Type == "FourthWeekly" ||
            this.LoanDetail.EMI_Type == "SingleEMI"
          ) {
            this.LoanDetail.Name = "Days";
            this.Name = "Days";
          } else {
            this.LoanDetail.Name = "Months";
            this.Name = "Months";
          }
          this.stepEMIProposed = [];
          if (
            res.Item1[0].Application_IRR_CalculateBy == "ROI" ||
            res.Item2[0].Application_IRR_CalculateBy == "Reducing_ROI"
          ) {
            this.stepEMIProposed.push({
              FromEMI: 1,
              ToEMI: res.Item1[0].No_Of_Instl,
              EMI_Amount: this.emiIrrProposed.EMI_Amt.toFixed(2),
              NoOfInstl: res.Item1[0].No_Of_Instl,
              TotalAmount: this.emiIrrProposed.Agreement_Value.toFixed(2),
              disable: true,
            });
          }
          if (res.Item1[0].Application_IRR_CalculateBy == "STEP_EMI") {
            this.stepEMIProposed = [];
            this._QuickLoanService
              .QuickLoan_Get_StepEMI({
                LoanId: this.loanSummary.LoanId,
                Id: res.Item1[0].RestructureId,
              })
              .subscribe((res: any) => {
                this.stepEMIProposed = res;

                for (let i = 0; i < res.length; i++) {
                  this.stepEMIProposed[i].EMI_Amount = res[i].EMIAmount;
                  this.stepEMIProposed[i].NoOfInstl = res[i].NoOfEMI;
                }
                this.getTotlaEmiAndAmountProposed();
              });
          }
          if (res.Item1[0].Application_IRR_CalculateBy == "FLAT_EMI") {
            this.stepEMIProposed.push({
              FromEMI: 1,
              ToEMI: res.Item1[0].No_Of_Instl,
              EMI_Amount: this.emiIrrProposed.EMI_Amt.toFixed(2),
              NoOfInstl: res.Item1[0].No_Of_Instl,
              TotalAmount: this.emiIrrProposed.Agreement_Value.toFixed(2),
              disable: true,
            });
          }

          if (res.Item2.length > 0) {
            this.LoanDetailApproved = res.Item2[0];
            let dataApproved = {
              Disbursement_Amt: res.Item2[0].DisbursementAmt,
              Interest_Amt: res.Item2[0].InterestAmt,
              Agreement_Value: res.Item2[0].AgreementValue,
              LTV: res.Item2[0].LTV,
              ROI: res.Item2[0].Flat_Rate,
              EMI_Amt: res.Item2[0].Application_LoanEMIAmount,
              Case_IRR: res.Item2[0].Case_IRR,
              Disbursement_IRR: res.Item2[0].Disbursement_IRR,
              Margin: res.Item2[0].Margin,
            };
            if (res.Item2[0].Type == "Sanction") {
              this.LoanDetailApproved.Heading = "Recommended";
            } else {
              this.LoanDetailApproved.Heading = "Approved";
            }
            this.emiIrrdataApproved = dataApproved;
            if (
              this.LoanDetailApproved.EMI_Type == "Daily" ||
              this.LoanDetailApproved.EMI_Type == "Weekly" ||
              this.LoanDetailApproved.EMI_Type == "Fortnightly" ||
              this.LoanDetailApproved.EMI_Type == "ByWeekly" ||
              this.LoanDetailApproved.EMI_Type == "FourthWeekly" ||
              this.LoanDetailApproved.EMI_Type == "SingleEMI"
            ) {
              this.LoanDetailApproved.Name = "Days";
              this.Name = "Days";
            } else {
              this.LoanDetailApproved.Name = "Months";
              this.Name = "Months";
            }
            this.stepEMIApproved = [];
            if (
              res.Item2[0].Application_IRR_CalculateBy == "ROI" ||
              res.Item2[0].Application_IRR_CalculateBy == "Reducing_ROI"
            ) {
              this.stepEMIApproved.push({
                FromEMI: 1,
                ToEMI: res.Item2[0].No_Of_Instl,
                EMI_Amount: this.emiIrrdataApproved.EMI_Amt.toFixed(2),
                NoOfInstl: res.Item2[0].No_Of_Instl,
                TotalAmount: this.emiIrrdataApproved.Agreement_Value.toFixed(2),
                disable: true,
              });
            }
            if (res.Item2[0].Application_IRR_CalculateBy == "STEP_EMI") {
              this.stepEMIApproved = [];
              this._QuickLoanService
                .QuickLoan_Get_StepEMI({
                  LoanId: this.loanSummary.LoanId,
                  Id: res.Item2[0].RestructureId,
                })
                .subscribe((res: any) => {
                  this.stepEMIApproved = res;

                  for (let i = 0; i < res.length; i++) {
                    this.stepEMIApproved[i].EMI_Amount = res[i].EMIAmount;
                    this.stepEMIApproved[i].NoOfInstl = res[i].NoOfEMI;
                  }
                  this.getTotlaEmiAndAmountApproved();
                });
            }
            if (res.Item2[0].Application_IRR_CalculateBy == "FLAT_EMI") {
              this.stepEMIApproved.push({
                FromEMI: 1,
                ToEMI: res.Item2[0].No_Of_Instl,
                EMI_Amount: this.emiIrrdataApproved.EMI_Amt.toFixed(2),
                NoOfInstl: res.Item2[0].No_Of_Instl,
                TotalAmount: this.emiIrrdataApproved.Agreement_Value.toFixed(2),
                disable: true,
              });
            }

            if (res.Item2[0].Application_IRR_CalculateBy) {
              this.cEIModel.Asset_Cost = res.Item2[0].AssetCost
                ? res.Item2[0].AssetCost == -1 || res.Item2[0].AssetCost == 0
                  ? 0
                  : res.Item2[0].AssetCost
                : 0;

              this.cEIModel.EMI_Type = res.Item2[0].EMI_Type;
              this.cEIModel.No_Of_Inst = res.Item2[0].No_Of_Instl;
              this.cEIModel.Tenure = res.Item2[0].Tenure;
              this.cEIModel.Adv_Inst = res.Item2[0].Adv_Instl;
              this.cEIModel.MgmtFee = res.Item2[0].ManagementFee;
              this.cEIModel.First_EMI_Date = new Date(
                res.Item2[0].FirstEMIDate
              );
              this.cEIModel.Flat_Rate = res.Item2[0].Flat_Rate;
              this.cEIModel.EMI_Amount = res.Item2[0].Application_LoanEMIAmount;

              this.cEIModel.Loan_Date = new Date(res.Item2[0].Loan_Date);
              this.cEIModel.LoanMaturityDate = new Date(
                res.Item2[0].LoanMaturityDate
              );
              this.cEIModel.ROI_Input_mathod = res.Item2[0].ROI_Input_mathod;

              if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI")
                this.isFrequency = true;
              $(function () {
                $("#Flat_Rate").val(res.Item2[0].Flat_Rate);
              });

              $(function () {
                $("#EMI_Amounts").val(res.Item2[0].Application_LoanEMIAmount);
              });
              if (
                this.KeyFectoreLoanAmount &&
                res.Item1[0].RestructureId == res.Item2[0].RestructureId
              ) {
                this.cEIModel.NetFinance_Amt = this.KeyFectoreLoanAmount;
                this.cEIModel.IRR_CalculateBy = "Reducing_ROI";
                this.cEIModel.Reducing_ROI = this.KeyFectoreIRR;
                this.onCalculateEmiAndIRR();
              } else {
                this.cEIModel.NetFinance_Amt = res.Item2[0].NetFinance;
                this.cEIModel.IRR_CalculateBy =
                  res.Item2[0].Application_IRR_CalculateBy;
                this.cEIModel.Reducing_ROI = res.Item2[0].Case_IRR;
                let data = {
                  Disbursement_Amt: res.Item2[0].DisbursementAmt,
                  Interest_Amt: res.Item2[0].InterestAmt,
                  Agreement_Value: res.Item2[0].AgreementValue,
                  LTV: res.Item2[0].LTV,
                  ROI: res.Item2[0].Flat_Rate,
                  EMI_Amt: res.Item2[0].Application_LoanEMIAmount,
                  Case_IRR: res.Item2[0].Case_IRR,
                  Disbursement_IRR: res.Item2[0].Disbursement_IRR,
                  Margin: res.Item2[0].Margin,
                };
                this.stepEMI = [];
                this.emiIrr = data;
              }

              if (
                res.Item2[0].Application_IRR_CalculateBy == "ROI" ||
                res.Item2[0].Application_IRR_CalculateBy == "Reducing_ROI"
              ) {
                this.stepEMI.push({
                  FromEMI: 1,
                  ToEMI: this.cEIModel.No_Of_Inst,
                  EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
                  NoOfInstl: this.cEIModel.No_Of_Inst,
                  TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
                  disable: true,
                });
              }
              if (res.Item2[0].Application_IRR_CalculateBy == "STEP_EMI") {
                let stepArr: any[] = [];
                this.cEIModel.IsStep = true;
                this._QuickLoanService
                  .QuickLoan_Get_StepEMI({
                    LoanId: this.loanSummary.LoanId,
                    Id: res.Item2[0].RestructureId,
                  })
                  .subscribe((res: any) => {
                    this.stepEMI = res;

                    for (let i = 0; i < res.length; i++) {
                      this.stepEMI[i].EMI_Amount = res[i].EMIAmount;
                      this.stepEMI[i].NoOfInstl = res[i].NoOfEMI;
                      for (
                        let j = +this.stepEMI[i].FromEMI;
                        j <= +this.stepEMI[i].ToEMI;
                        j++
                      ) {
                        if (+this.stepEMI[i].EMI_Amount >= 0) {
                          stepArr.push(this.stepEMI[i].EMI_Amount);
                        }
                      }
                    }
                    this.getTotlaEmiAndAmount();
                  });
              }
              if (res.Item2[0].Application_IRR_CalculateBy == "FLAT_EMI") {
                this.stepEMI.push({
                  FromEMI: 1,
                  ToEMI: this.cEIModel.No_Of_Inst,
                  EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
                  NoOfInstl: this.cEIModel.No_Of_Inst,
                  TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
                  disable: true,
                });
              }
            }
          }
        }

        this.showSpinner = false;
      });
  }
  addSanctionFinancial() {
    $("#loanFinancialDetailsModel").modal("show");
    $("#loanFinancialDetailsModel").css("z-index", "1050");
    this.getLoanAccount();
  }
  onCloseDialog() {
    $("#loanFinancialDetailsModel").modal("hide");
  }
  setTenure() {
    if (this.cEIModel.No_Of_Inst && this.cEIModel.EMI_Type != "SingleEMI") {
      if (this.cEIModel.EMI_Type == "ByMonthly") {
        this.cEIModel.Tenure = 2 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Quarterly") {
        this.cEIModel.Tenure = 3 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "HalfYearly") {
        this.cEIModel.Tenure = 6 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Yearly") {
        this.cEIModel.Tenure = 12 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Weekly") {
        this.cEIModel.Tenure = 7 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Fortnightly") {
        this.cEIModel.Tenure = 15 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "ByWeekly") {
        this.cEIModel.Tenure = 14 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "FourthWeekly") {
        this.cEIModel.Tenure = 28 * +this.cEIModel.No_Of_Inst;
      } else {
        this.cEIModel.Tenure = this.cEIModel.No_Of_Inst;
      }
      if (
        this.cEIModel.EMI_Type == "Daily" ||
        this.cEIModel.EMI_Type == "Weekly" ||
        this.cEIModel.EMI_Type == "Fortnightly" ||
        this.cEIModel.EMI_Type == "ByWeekly" ||
        this.cEIModel.EMI_Type == "FourthWeekly" ||
        this.cEIModel.EMI_Type == "SingleEMI"
      )
        this.Name = "Days";
      else this.Name = "Months";
    }
    this.setAdvanceInstl();
  }
  setAdvanceInstl() {
    if (Number(this.cEIModel.Adv_Inst) >= Number(this.cEIModel.No_Of_Inst)) {
      this.cEIModel.Adv_Inst = 0;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Advance Installment not greater than No. Of Installment !!!",
        ...this.configSuccess,
      });
    }
  }
  addNextStep(data: any) {
    if (+data.ToEMI <= 0 || +data.EMI_Amount < 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Fill All Data.",
        ...this.configSuccess,
      });
      return;
    } else if (+data.ToEMI > +this.cEIModel.No_Of_Inst) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "To Emi can not be greater than number of installment.",
        ...this.configSuccess,
      });
      return;
    } else {
      if (+data.FromEMI > +data.ToEMI) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To EMI should be greater than From EMI.",
          ...this.configSuccess,
        });
        return;
      }
      data.NoOfInstl = +data.ToEMI - +data.FromEMI + 1;
      data.TotalAmount = data.NoOfInstl * +data.EMI_Amount;
      if (+data.ToEMI < +this.cEIModel.No_Of_Inst) {
        data.disable = true;
        this.stepEMI.push({
          FromEMI: +data.ToEMI + 1,
          ToEMI: "",
          EMI_Amount: "",
          disable: false,
        });
      }
      this.getTotlaEmiAndAmount();
    }
  }
  getTotlaEmiAndAmount() {
    if (this.stepEMI.length > 1) {
      let TotalEmi: any = 0,
        TotalAmount: any = 0;
      for (let i = 0; i < this.stepEMI.length; i++) {
        if (this.stepEMI[i].EMI_Amount) {
          TotalEmi =
            TotalEmi + (+this.stepEMI[i].ToEMI - +this.stepEMI[i].FromEMI + 1);
          TotalAmount =
            TotalAmount +
            (+this.stepEMI[i].ToEMI - +this.stepEMI[i].FromEMI + 1) *
            +this.stepEMI[i].EMI_Amount;
        }
      }
      this.stepEmiData = { totalEmi: TotalEmi, totalAmount: TotalAmount };
    } else {
      this.stepEmiData = undefined;
    }
  }
  getTotlaEmiAndAmountProposed() {
    if (this.stepEMIProposed.length > 1) {
      let TotalEmi: any = 0,
        TotalAmount: any = 0;
      for (let i = 0; i < this.stepEMIProposed.length; i++) {
        if (this.stepEMIProposed[i].EMI_Amount) {
          TotalEmi =
            TotalEmi +
            (+this.stepEMIProposed[i].ToEMI -
              +this.stepEMIProposed[i].FromEMI +
              1);
          TotalAmount =
            TotalAmount +
            (+this.stepEMIProposed[i].ToEMI -
              +this.stepEMIProposed[i].FromEMI +
              1) *
            +this.stepEMIProposed[i].EMI_Amount;
        }
      }
      this.stepEmiDataProposed = {
        totalEmi: TotalEmi,
        totalAmount: TotalAmount,
      };
    } else {
      this.stepEmiDataProposed = undefined;
    }
  }
  getTotlaEmiAndAmountApproved() {
    if (this.stepEMIApproved.length > 1) {
      let TotalEmi: any = 0,
        TotalAmount: any = 0;
      for (let i = 0; i < this.stepEMIApproved.length; i++) {
        if (this.stepEMIApproved[i].EMI_Amount) {
          TotalEmi =
            TotalEmi +
            (+this.stepEMIApproved[i].ToEMI -
              +this.stepEMIApproved[i].FromEMI +
              1);
          TotalAmount =
            TotalAmount +
            (+this.stepEMIApproved[i].ToEMI -
              +this.stepEMIApproved[i].FromEMI +
              1) *
            +this.stepEMIApproved[i].EMI_Amount;
        }
      }
      this.stepEmiDataApproved = {
        totalEmi: TotalEmi,
        totalAmount: TotalAmount,
      };
    } else {
      this.stepEmiDataApproved = undefined;
    }
  }
  removeLastStep(index: any) {
    this.stepEMI.splice(index, 1);
    this.stepEMI[index - 1].disable = false;
    this.getTotlaEmiAndAmount();
  }
  onCalculateEmiAndIRR() {
    let netAmount: any[] = [];
    let roi: any[] = [];

    if (+this.cEIModel.NetFinance_Amt <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Net Finance Amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.Flat_Rate < 0 &&
      this.cEIModel.IRR_CalculateBy == "ROI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Flat rate should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.EMI_Amount <= 0 &&
      this.cEIModel.IRR_CalculateBy == "FLAT_EMI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.No_Of_Inst <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.Tenure <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Tenure should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.cEIModel.IRR_CalculateBy == "FLAT_EMI" &&
      +this.cEIModel.EMI_Amount * +this.cEIModel.No_Of_Inst <
      +this.cEIModel.NetFinance_Amt
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment multiply by EMI amount should be greater than or equal to Net Finance Amount.",
        ...this.configSuccess,
      });
      return;
    }

    if (this.cEIModel.EMI_Type == "SingleEMI") {
      var ROI = parseFloat(this.cEIModel.Flat_Rate);
      if (this.cEIModel.ROI_Input_mathod == "Daily") {
        ROI = ROI * this.currentUser.DaysInYear;
      }
      var Interest_Amt = Math.round(
        ((parseFloat(this.cEIModel.NetFinance_Amt) * ROI) /
          100 /
          this.currentUser.DaysInYear) *
        this.cEIModel.Tenure
      );
      var Agreement_Value = Math.round(
        parseFloat(this.cEIModel.NetFinance_Amt) +
        parseFloat(Interest_Amt.toString())
      );

      let data = {
        Disbursement_Amt: this.cEIModel.NetFinance_Amt,
        Interest_Amt: Interest_Amt,
        Agreement_Value: Agreement_Value,
        ROI: parseFloat(this.cEIModel.Flat_Rate),
        EMI_Amt: Agreement_Value,
        Case_IRR: parseFloat(this.cEIModel.Flat_Rate),
        Disbursement_IRR: parseFloat(this.cEIModel.Flat_Rate),
        Margin: 0,
      };
      this.emiIrr = data;

      if (this.cEIModel.IRR_CalculateBy == "ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.EMI_Amt.toFixed(2);
        $(function () {
          $("#EMI_Amounts").val(amt);
        });
      }

      if (this.cEIModel.IRR_CalculateBy == "FLAT_EMI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.ROI.toFixed(2);
        $(function () {
          $("#Flat_Rate").val(amt);
        });
      }
    } else {
      if (this.selectedScheme.Amount) {
        netAmount = this.selectedScheme.Amount.split("-");
        roi = this.selectedScheme.ROI.split("-");
        if (
          +this.cEIModel.NetFinance_Amt > +netAmount[1] ||
          +this.cEIModel.NetFinance_Amt < +netAmount[0]
        ) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Net Finance Amount should be in between Scheme Amount.",
            ...this.configSuccess,
          });
          return;
        }
        if (
          this.cEIModel.IRR_CalculateBy == "ROI" &&
          (+this.cEIModel.Flat_Rate > +roi[1] ||
            +this.cEIModel.Flat_Rate < +roi[0])
        ) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Flate Rate should be in between Scheme ROI.",
            ...this.configSuccess,
          });
          return;
        }
        if (+this.cEIModel.Adv_Inst < +this.selectedScheme.AdvanceEMI) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Advance Installment can not be less than Scheme Advance EMI.",
            ...this.configSuccess,
          });
          return;
        }
        this.calculateEmiIrr();
      } else {
        this.calculateEmiIrr();
      }
    }
  }
  calculateEmiIrr() {
    let stepArr: any[] = [];
    if (this.cEIModel.IRR_CalculateBy == "STEP_EMI") {
      this.cEIModel.IsStep = true;
      if (this.stepEMI.length < 1) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Please add step EMI first",
          ...this.configSuccess,
        });
        return;
      }
      let lastEMI = this.stepEMI[this.stepEMI.length - 1].ToEMI;
      if (+lastEMI != +this.cEIModel.No_Of_Inst) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Should Be Equal To No of Installment",
          ...this.configSuccess,
        });
        return;
      }
      if (
        this.stepEmiData != undefined &&
        +this.stepEmiData.totalAmount < +this.cEIModel.NetFinance_Amt
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Amount should be  equal or Greater then  Net Finance Amount.",
          ...this.configSuccess,
        });
        return;
      }
      for (let i = 0; i < this.stepEMI.length; i++) {
        for (
          let j = +this.stepEMI[i].FromEMI;
          j <= +this.stepEMI[i].ToEMI;
          j++
        ) {
          if (+this.stepEMI[i].EMI_Amount >= 0) {
            stepArr.push(this.stepEMI[i].EMI_Amount);
          }
        }
      }
    } else {
      this.cEIModel.IsStep = false;
      this.cEIModel.STEP_IRR = 0;
    }
    let _data = { ...this.cEIModel };
    _data.cashflow = stepArr;
    if (this.cEIModel.IsStep) {
      _data.EMI_Amount = this.stepEmiData.totalAmount;
    }
    _data.DaysInYear = this.currentUser.DaysInYear;
    this.getCalculateEMIIRR(_data);
  }
  getCalculateEMIIRR(data: any) {
    this.showSpinner = true;
    data.DaysInYear = this.currentUser.DaysInYear;
    this.LmsService.LMS_GetCalculateEMIIRR(data).subscribe((res: any) => {
      this.showSpinner = false;
      this.emiIrr = res[0];
      setTimeout(() => {
        var elmntToView = document.getElementById("scrollto");
        elmntToView.scrollIntoView();
      }, 500);

      if (this.cEIModel.IRR_CalculateBy == "ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
      }
      if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
      }
      $("#EMI_Amounts").val(this.emiIrr.EMI_Amt.toFixed(2));
      if (this.cEIModel.IRR_CalculateBy == "FLAT_EMI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
      }
      $("#Flat_Rate").val(this.emiIrr.ROI.toFixed(2));
    });
  }
  onSaveApplication() {
    if (+this.cEIModel.NetFinance_Amt <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Net Finance Amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.Flat_Rate < 0 &&
      this.cEIModel.IRR_CalculateBy == "ROI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Flate rate should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.EMI_Amount <= 0 &&
      this.cEIModel.IRR_CalculateBy == "EMI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.No_Of_Inst <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.Tenure <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Tenure should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.cEIModel.IRR_CalculateBy !== "STEP_EMI" &&
      +this.cEIModel.No_Of_Inst * +this.emiIrr.EMI_Amt <
      +this.cEIModel.NetFinance_Amt
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI multiply with installment should be equal or grater than net finance.",
        ...this.configSuccess,
      });
      return;
    }
    if (this.cEIModel.IRR_Type == "Step") {
      let length = this.stepEMI.length;
      let ToEmi = this.stepEMI[length - 1].ToEMI;
      if (+ToEmi != +this.cEIModel.No_Of_Inst) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Add EMI step.",
          ...this.configSuccess,
        });
        return;
      }
      if (
        this.emiIrr.Disbursement_Amt + this.emiIrr.Interest_Amt !=
        +this.stepEmiData.totalAmount
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Amount must be equal to  (Disbursement Amount  + Interest Amount)",
          ...this.configSuccess,
        });
        return;
      }
    }
    let _stepEmi: any[] = [];
    this.stepEMI.forEach((obj: any) => {
      _stepEmi.push(this.dataSharingService.cleanObject({ ...obj }));
    });

    if (
      this.emiIrr.Interest_Amt == null ||
      this.emiIrr.Interest_Amt == 0 ||
      this.emiIrr.Interest_Amt == ""
    ) {
      this.emiIrr.Interest_Amt = 0;
      this.emiIrr.Case_IRR = 0;
      this.emiIrr.Disbursement_IRR = 0;
    }
    let data = {
      Application: this.dataSharingService.cleanObject({
        LoanId: this.loanSummary.LoanId,
        BranchId: 1,
        ProductId: this.cEIModel.ProductId,
        Asset_Cost: this.cEIModel.Asset_Cost,
        NetFinance_Amt: this.cEIModel.NetFinance_Amt,
        Flat_Rate: this.emiIrr.ROI,
        No_Of_Inst: this.cEIModel.No_Of_Inst,
        Tenure: this.cEIModel.Tenure,
        Adv_Inst: this.cEIModel.Adv_Inst,
        MgmtFee: 0,
        EMI_Type: this.cEIModel.EMI_Type,
        Disbursement_Amt: this.emiIrr.Disbursement_Amt,
        Interest_Amt: this.emiIrr.Interest_Amt,
        Agreement_Value: this.emiIrr.Agreement_Value,
        LTV: this.emiIrr.LTV,
        EMI_Amt: this.emiIrr.EMI_Amt,
        Case_IRR: this.emiIrr.Case_IRR,
        Disbursement_IRR: this.emiIrr.Disbursement_IRR,
        Loan_Purpose: this.cEIModel.Purpose,
        Loan_SchemeId: this.selectedScheme.SchemeId,
        FirstEMIDate: this.cEIModel.First_EMI_Date,
        IRR_Type: this.cEIModel.IRR_Type,
        LoginUserId: this.currentUser.userId,
        ROI: this.emiIrr.ROI,
        EMI_Amount: this.cEIModel.EMI_Amount,
        IRR_CalculateBy: this.cEIModel.IRR_CalculateBy,
        LoanMaturityDate: this.cEIModel.LoanMaturityDate,
        Loan_Date: this.cEIModel.Loan_Date,
        ProcessingFeePercentage: this.cEIModel.ProcessingFee,
      }),
      StepIRR: _stepEmi,
    };

    this._QuickLoanService
      .QuickLoan_Update_Financial_Sanction({ JSON: JSON.stringify(data) })
      .subscribe((res: any) => {
        if (res) {
          if (res[0] ? res[0].CODE >= 0 : false) {
            if (this.Processid == 8 || this.Processid == 2)
              this.getLoanAccount();
            this.QuickLoan_Save_PageProcess("Sanction Conditions");

            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
            this.onCloseDialog();
          } else if (res[0]) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
          }
        }
      });
  }
  setType(event: any) {
    if (this.cEIModel.IRR_CalculateBy == "STEP_EMI") {
      this.stepEmiForm = true;
      this.cEIModel.EMI_Type = "Monthly";
      this.cEIModel.Tenure = this.cEIModel.No_Of_Inst;
    }
    if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI")
      this.isFrequency = true;
    else this.isFrequency = false;

    this.emiIrr = undefined;
    if (this.cEIModel.IRR_CalculateBy == "ROI") {
      delete this.cEIModel.EMI_Amount;
    } else {
      delete this.cEIModel.Flat_Rate;
    }

    if (this.cEIModel.IRR_CalculateBy !== "STEP_EMI") {
      this.stepEMI = [];
    } else {
      this.stepEMI.push({
        FromEMI: 1,
        ToEMI: "",
        EMI_Amount: "",
        disable: false,
      });
      this.stepEmiData = undefined;
    }
  }
  OnCompletedSanctionConditions() {
    let FilterProductData = this.Headers.filter((a) => a.IsCompleted == true);
    var Ids = Array.prototype.map
      .call(FilterProductData, function (item) {
        return item.Id;
      })
      .join(",");
    this._QuickLoanService
      .QuickLoan_Completed_Sanction_Conditions({
        Ids: Ids,
        LoginUserId: this.currentUser.userId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((response: any) => {
        if (response[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.GetSanctionConditions();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }
  onSanctionFinancialApproved() {
    this.dialogreturn = this.dialog.openConfirmDialog(
      "Are you sure you want to Accept these Financial?"
    );
    this.dialogreturn.afterClosed().subscribe((dialogResult) => {
      if (dialogResult == true) {
        this._QuickLoanService
          .QuickLoan_Accept_Financial_Sanction({
            Id: this.LoanDetailApproved.RestructureId,
            LoanId: this.loanSummary.LoanId,
          })
          .subscribe((response) => {
            if (response[0].CODE == 0) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
              this.GetSanctionConditions();
              this.getLoanAccount();
              this.onCloseDialog();




            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
            }
          });
      }
    });
  }
  DaysDifference() {
    if (
      this.cEIModel.Loan_Date != null &&
      this.cEIModel.LoanMaturityDate != null &&
      this.cEIModel.LoanMaturityDate != undefined
    ) {
      const startTime = new Date(this.cEIModel.Loan_Date).getTime();
      const endTime = new Date(this.cEIModel.LoanMaturityDate).getTime();
      const difference = endTime - startTime;

      this.cEIModel.Tenure = Math.ceil(difference / (1000 * 3600 * 24));
      this.emiIrr = undefined;
    }
  }
  ChangeText() {
    this.emiIrr = undefined;
  }
  changeLoan_Date() {
    var year = new Date(this.cEIModel.Loan_Date).getFullYear();
    var month = new Date(this.cEIModel.Loan_Date).getMonth();
    var day = new Date(this.cEIModel.Loan_Date).getDate();
    var c = new Date(year, month, day + 1);
    this.minLoanMaturityDate = c;
    this.DaysDifference();
  }
  LMS_Get_DV_Details() {
    this.showSpinner = true;
    this.lmsService
      .LMS_Get_DV_Details({ LoanAcId: this.LoanId, VoucherId: this.VoucherId })
      .subscribe((res: any) => {
        this.dvDetail = res.Item1[0];

        this.stepArr = res.Item4;
        this.authRevertStatus = this.dvDetail.VoucherStatus
          ? this.dvDetail.VoucherStatus == "Authorized" ||
            this.dvDetail.VoucherStatus == "Reverted"
            ? this.dvDetail.VoucherStatus
            : ""
          : "";
        this.voucherRemark = this.dvDetail.VoucherStatus
          ? this.dvDetail.VoucherStatus != "Pending"
            ? this.dvDetail.Remark
            : ""
          : "";
        this.deductionList = res.Item2;
        this.receiptList = res.Item3;
        this.dataSource = new MatTableDataSource(this.receiptList);
        this.showSpinner = false;
        if (
          this.dvDetail.EMI_Type == "Daily" ||
          this.dvDetail.EMI_Type == "Weekly" ||
          this.dvDetail.EMI_Type == "Fortnightly" ||
          this.dvDetail.EMI_Type == "ByWeekly" ||
          this.dvDetail.EMI_Type == "FourthWeekly" ||
          this.dvDetail.EMI_Type == "SingleEMI"
        )
          this.Tenure_Name = "Days";
        else this.Tenure_Name = "Months";
        this.initializeVoucher();
        this.deductionList.map((item) => {
          if (!item.IsTax) {
            this.voucherModel.Voucher_Detail.push({
              ...item,
              TaxSlab: [],
            });
          } else if (this.voucherModel.Voucher_Detail.length > 1) {
            this.voucherModel.Voucher_Detail[
              this.voucherModel.Voucher_Detail.length - 1
            ].TaxSlab.push(item);
          }
        });
        this.GetCustomerDetails();
        this.getTotalCalculation();
      });
  }

  initializeVoucher() {
    this.voucherModel.Voucher = {
      Voucher_LoanId: this.dvDetail.LoanId,
      VoucherId: 0,
      Voucher_Type: "Disbursement",
      Voucher_Sub_Type: "Loan",
      Voucher_Tag: "",
      Voucher_Date: moment(this.dvDetail.VoucherDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      ),
      Voucher_No: this.dvDetail.VoucherNo,
      DRAccountId: "",
      Voucher_Mode_of_Payment: "",
      Voucher_Total_Credit_Amount: "",
      Voucher_Total_Debit_Amount: "",
      Voucher_Total_Tax: "",
      Voucher_Narration: this.dvDetail.Voucher_Narration,
      Voucher_Cheque_No: "",
      Voucher_Cheque_Date: "",
      Voucher_Bank_Name: "",
      Voucher_Cheque_Clear_Date: "",
      Voucher_E_Transaction_Date: "",
      Voucher_E_Ref_No: "",
      Voucher_ReceiptNo_Book: "",
      Voucher_ReceiptDate: "",
      LoginUserId: this.currentUser.userId,
    };
  }
  getTotalCalculation() {
    let _totalCR: any = 0;
    let _totalDR: any = 0;
    let _totalCRTX: any = 0;
    let _totalDRTX: any = 0;
    this.voucherModel.Voucher_Detail.forEach((obj: any) => {
      if (obj.Type == "CR") {
        _totalCR = _totalCR + parseFloat(obj.Amount) || 0;
      } else {
        _totalDR = _totalDR + parseFloat(obj.Amount) || 0;
      }
      obj.TaxSlab.forEach((tobj: any) => {
        if (obj.Type == "CR") {
          _totalCR = _totalCR + parseFloat(tobj.Amount) || 0;
          _totalCRTX = _totalCRTX + parseFloat(tobj.Amount) || 0;
        } else {
          _totalDR = _totalDR + parseFloat(tobj.Amount) || 0;
          _totalDRTX = _totalDRTX + parseFloat(tobj.Amount) || 0;
        }
      });
    });
    this.totalCalculator = {
      totalCR: parseFloat(_totalCR),
      totalDR: parseFloat(_totalDR),
      totalCRTX: parseFloat(_totalCRTX),
      totalDRTX: parseFloat(_totalDRTX),
      totalCRInWord: new ToWords().convert(parseFloat(_totalCR)),
      totalDRInWord: new ToWords().convert(parseFloat(_totalDR)),
    };
  }
  GetCustomerDetails() {
    this.lmsService
      .LMS_GetLoanDetails({ Loan_Id: this.loanSummary.LoanId })
      .subscribe((res: any) => {
        this.displayedCustomerDetailColumns = [
          "CustomerId",
          "Customer",
          "CustomerType",
          "GenderAge",
          "PhoneNo",
          "Relation_With_Hirer",
          "ExistingCustomer",
        ];
        this.dataSourceCustomerDetail = [];
        if (res.Item2.length > 0) {
          var customerList = [];
          var adharList = [];
          res.Item2.forEach((x) => {
            if (customerList.length < 4) {
              this.dataSourceCustomerDetail.push(x);
              if (this.loanSummary.IsReasonSendEsign) {
                customerList.push({
                  identifier: x.Customer_Email == null ? x.PhoneNo.toString() : x.Customer_Email.toString(),
                  name: x.Customer.toString(),
                  sign_type: "AADHAAR",
                  reason:
                    "Loan Ref(" +
                    this.loanSummary.ApplicationNo +
                    " - " +
                    x.CustomerType +
                    ")",
                  signing_addons: [
                    {
                      type: "GEO_LOCATION",
                      perform_enrichment: true,
                    },
                  ],
                });
              } else {
                customerList.push({
                  identifier: x.Customer_Email == null ? x.PhoneNo.toString() : x.Customer_Email.toString(),
                  name: x.Customer.toString(),
                  sign_type: "AADHAAR",
                  signing_addons: [
                    {
                      type: "GEO_LOCATION",
                      perform_enrichment: true,
                    },
                  ],
                });
              }

              adharList.push({
                [x.PhoneNo]: {
                  abort_on_fail: "true",
                  max_attempt: 3,
                  rules: [
                    {
                      operation: "AND",
                      conditions: [
                        {
                          field: "gender",
                          match_type: "exact",
                          value: x.GenderAge.split(",")[0][0],
                        },
                        {
                          field: "aadhaar",
                          match_type: "exact",
                          value: x.AADHAARNo?.slice(-4),
                        },
                      ],
                    },
                  ],
                },
              });
            }
          });
          $("#totalCustomer").text(this.dataSourceCustomerDetail.length);
          console.log(
            "this.dataSourceCustomerDetail.length",
            this.dataSourceCustomerDetail.length
          );

          const flatData: { [key: string]: any } = {};

          adharList.forEach((entry) => {
            const key = Object.keys(entry)[0];
            flatData[key] = entry[key];
          });
          this.customerList = JSON.stringify(customerList);
          this.adharList = JSON.stringify(flatData);
          console.log("his.adharList", JSON.stringify(flatData));

          console.log("his.customerList", JSON.stringify(customerList));
        }

        if (res.Item9.length > 0) {
          this.dataSourceEsign = new MatTableDataSource(
            JSON.parse(JSON.stringify(res.Item9))
          );
          this.displayedColumnsEsign = ["Id", "Status", "UploadId", "Action"];
        } else {
          this.dataSourceEsign = null;
        }
      });
  }
  fileChangeListener(files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    let $this = this;
    let reader = new FileReader();
    this.selectedEsignFile = files[0].name;
    this.DocModel.DocName = files[0].name;
    this.DocModel.ApplicationNo = this.loanSummary.ApplicationNo;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      $this.DocModel.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
    console.log("this.DocModel", this.DocModel);
  }
  removeFile(input: any) {
    input.value = "";
    this.selectedEsignFile = "";
    this.DocModel.DocName = "";
    this.DocModel.DocData = "";
  }
  fileChangeListener1(files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    let $this = this;
    let reader = new FileReader();
    this.selectedEsignSanctionFile = files[0].name;
    this.DocModelSanction.DocName = files[0].name;
    this.DocModelSanction.ApplicationNo = this.loanSummary.ApplicationNo;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      $this.DocModelSanction.DocData = reader.result
        .toString()
        .split(";base64,")
        .pop();
      return;
    };
  }
  removeFile1(input: any) {
    input.value = "";
    this.selectedEsignSanctionFile = "";
    this.DocModelSanction.DocName = "";
    this.DocModelSanction.DocData = "";
  }
  cleanHtmlForPdf(html: string): string {
    html = html.replace(/_ngcontent-[^=]+="[^"]*"/g, "");
    html = html.replace(/_ngcontent-[^=]+='[^']*'/g, "");
    html = html.replace(/_ngcontent-[^=]+=[^ >]+/g, "");
    html = html.replace(/<a[^>]*><\/a>/g, "");
    html = html.replace(/<font([^>]*)>/g, "<span$1>");
    html = html.replace(/<\/font>/g, "</span>");

    html = html.replace(/width="[^"]*"/g, (match) => {
      if (/\d+%/.test(match)) {
        const pct = match.match(/\d+%/);
        return `style="width: ${pct ? pct[0] : "100%"}; max-width: 100%;"`;
      }
      return `style="width: 100%; max-width: 100%;"`;
    });

    html = html.replace(
      /style=("|')[^"']*width\s*:\s*[^;"']+;?[^"']*("|')/gi,
      (match) => {
        const other = match
          .replace(/(\bwidth\s*:\s*[^;]+;?)/i, "")
          .replace(/^style=("|')|("|')$/g, "");
        const cleanedOther = other.trim();
        return `style="${cleanedOther}${cleanedOther ? "; " : ""
          }width: 100%; max-width: 100%;"`;
      }
    );

    html = html.replace(
      /<table(?![^>]*\bstyle=)(\s|>)/gi,
      '<table style="width:100%; table-layout:fixed; word-break:break-word;"$1'
    );
    html = html.replace(
      /<img(?![^>]*\bstyle=)(\s|>)/gi,
      '<img style="max-width:100%; height:auto;"$1'
    );

    html = html.replace(
      /<td(?![^>]*\bstyle=)(\s|>)/gi,
      '<td style="word-break:break-word; word-wrap:break-word; overflow-wrap:break-word;"$1'
    );

    return html;
  }
  OnESign() {
    var request = "";
    if (this.loanSummary.IsReasonSendEsign) {
      request =
        '{ "sign_coordinates": {' +
        '"email/mobile": {' +
        '"1": [' +
        "{" +
        ' "llx":3, ' +
        ' "lly":0,' +
        '"urx":142, ' +
        ' "ury":39' +
        "} " +
        " ], " +
        '"5": [' +
        " {" +
        '"llx":29, ' +
        ' "lly":416, ' +
        ' "urx":197, ' +
        ' "ury":456' +
        "}" +
        "]" +
        "} " +
        "}," +
        '"signature_verification": {' +
        '"0": {' +
        '"abort_on_fail": "true",' +
        '"max_attempt": 3,' +
        ' "rules": [' +
        " {" +
        '"operation": "AND",' +
        ' "conditions": [' +
        "{" +
        '  "field": "aadhaar",' +
        ' "match_type": "EXACT",' +
        ' "value": "' +
        this.loanSummary.AADHAARNo +
        '"' +
        " }" +
        "]" +
        "}" +
        " ]" +
        "}" +
        "}, " +
        '"signers": [{' +
        '"identifier": "' +
        this.loanSummary.Customer_Email +
        '", "name": "' +
        this.loanSummary.Customer +
        '", "sign_type": "AADHAAR","reason": "Loan Ref(' +
        this.loanSummary.ApplicationNo +
        ')", "signing_addons": [ { "type": "GEO_LOCATION", "perform_enrichment": true  }] } ], "expire_in_days": 3, "generate_access_token": true, "display_on_page": "All", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
    } else {
      request =
        '{ "sign_coordinates": {' +
        '"email/mobile": {' +
        '"1": [' +
        "{" +
        ' "llx":3, ' +
        ' "lly":0,' +
        '"urx":142, ' +
        ' "ury":39' +
        "} " +
        " ], " +
        '"5": [' +
        " {" +
        '"llx":29, ' +
        ' "lly":416, ' +
        ' "urx":197, ' +
        ' "ury":456' +
        "}" +
        "]" +
        "} " +
        "}," +
        '"signature_verification": {' +
        '"0": {' +
        '"abort_on_fail": "true",' +
        '"max_attempt": 3,' +
        ' "rules": [' +
        " {" +
        '"operation": "AND",' +
        ' "conditions": [' +
        "{" +
        '  "field": "aadhaar",' +
        ' "match_type": "exact",' +
        ' "value": "' +
        this.loanSummary.AADHAARNo +
        '"' +
        " }" +
        "]" +
        "}" +
        " ]" +
        "}" +
        "}, " +
        '"signers": [{' +
        '"identifier": "' +
        this.loanSummary.Customer_Email +
        '", "name": "' +
        this.loanSummary.Customer +
        '", "sign_type": "AADHAAR", "signing_addons": [ { "type": "GEO_LOCATION", "perform_enrichment": true  }] } ], "expire_in_days": 3, "generate_access_token": true, "display_on_page": "All", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
    }

    this._QuickLoanService
      .digioEsignRequest({
        base64String: this.DocModel.DocData,
        fileName: this.DocModel.DocName,
        text: request,
        LoanId: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        Type: "Agreement",
      })
      .subscribe(
        (response: any) => {
          if (response.length > 0 && response[0].CODE >= 0) {
            console.log("File uploaded successfully!", response);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "Upload E-sign Requested Successfully!!",
              ...this.configSuccess,
            });
            this.loanSummary.Digio_Esign_Status = "requested";
            this.loanSummary.Digio_Esign_UploadId = response[0].MSG;
          } else {
            console.log("File uploaded successfully!", response);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        (error) => {
          console.error("Error uploading file:", error);
        }
      );

    this.OnCloseAgreementModal();
  }
  OnESignSanction() {
    var request = "";
    if (this.loanSummary.IsReasonSendEsign) {
      request =
        '{ "sign_coordinates": {' +
        '"email/mobile": {' +
        '"1": [' +
        "{" +
        ' "llx":3, ' +
        ' "lly":0,' +
        '"urx":142, ' +
        ' "ury":39' +
        "} " +
        " ], " +
        '"5": [' +
        " {" +
        '"llx":29, ' +
        ' "lly":416, ' +
        ' "urx":197, ' +
        ' "ury":456' +
        "}" +
        "]" +
        "} " +
        "}," +
        '"signature_verification": {' +
        '"0": {' +
        '"abort_on_fail": "true",' +
        '"max_attempt": 3,' +
        ' "rules": [' +
        " {" +
        '"operation": "AND",' +
        ' "conditions": [' +
        "{" +
        '  "field": "aadhaar",' +
        ' "match_type": "exact",' +
        ' "value": "' +
        this.loanSummary.AADHAARNo +
        '"' +
        " }" +
        "]" +
        "}" +
        " ]" +
        "}" +
        "}, " +
        '"signers": [{' +
        '"identifier": "' +
        this.loanSummary.Customer_Email +
        '", "name": "' +
        this.loanSummary.Customer +
        '", "sign_type": "AADHAAR","reason": "Loan Ref(' +
        this.loanSummary.ApplicationNo +
        ')", "signing_addons": [ { "type": "GEO_LOCATION", "perform_enrichment": true  }] } ], "expire_in_days": 3, "generate_access_token": true, "display_on_page": "All", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
    } else {
      request =
        '{ "sign_coordinates": {' +
        '"email/mobile": {' +
        '"1": [' +
        "{" +
        ' "llx":3, ' +
        ' "lly":0,' +
        '"urx":142, ' +
        ' "ury":39' +
        "} " +
        " ], " +
        '"5": [' +
        " {" +
        '"llx":29, ' +
        ' "lly":416, ' +
        ' "urx":197, ' +
        ' "ury":456' +
        "}" +
        "]" +
        "} " +
        "}," +
        '"signature_verification": {' +
        '"0": {' +
        '"abort_on_fail": "true",' +
        '"max_attempt": 3,' +
        ' "rules": [' +
        " {" +
        '"operation": "AND",' +
        ' "conditions": [' +
        "{" +
        '  "field": "aadhaar",' +
        ' "match_type": "exact",' +
        ' "value": "' +
        this.loanSummary.AADHAARNo +
        '"' +
        " }" +
        "]" +
        "}" +
        " ]" +
        "}" +
        "}, " +
        '"signers": [{' +
        '"identifier": "' +
        this.loanSummary.Customer_Email +
        '", "name": "' +
        this.loanSummary.Customer +
        '", "sign_type": "AADHAAR", "signing_addons": [ { "type": "GEO_LOCATION", "perform_enrichment": true  }] } ], "expire_in_days": 3, "generate_access_token": true, "display_on_page": "All", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
    }

    this._QuickLoanService
      .digioEsignRequest({
        base64String: this.DocModelSanction.DocData,
        fileName: this.DocModelSanction.DocName,
        text: request,
        LoanId: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        Type: "Sanction",
      })
      .subscribe(
        (response: any) => {
          if (response.length > 0 && response[0].CODE >= 0) {
            console.log("File uploaded successfully!", response);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "Upload E-sign Requested Successfully!!",
              ...this.configSuccess,
            });
            this.loanSummary.Digio_Esign_Sanction_Status = "requested";
            this.loanSummary.Digio_Esign_Sanction_UploadId = response[0].MSG;
          } else {
            console.log("File uploaded successfully!", response);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },

        (error) => {
          console.error("Error uploading file:", error);
        }
      );

    this.OnCloseSanctionModal();
  }
  ShowCAMReport() {
    $("#CAMReport").modal("show");
    $("#CAMReport").css("z-index", "1050");
  }
  HideCAMReport() {
    $("#CAMReport").modal("hide");
  }

  openESignModel() {
    console.log("loan summaryyyyyyy", this.loanSummary);

    if (this.loanSummary.Customer_Email) {
      if (this.loanSummary.AADHAARNo) {
        $("#agreementUploadEsign").modal("show");
        $("#agreementUploadEsign").css("z-index", "1050");
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "This document can not be uploaded because AADHAAR NO is not Added.",
          ...this.configSuccess,
        });
      }
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "This document can not be uploaded because email id is not find.",
        ...this.configSuccess,
      });
    }
  }
  openESignSanctionModel() {
    if (this.loanSummary.Customer_Email) {
      if (this.loanSummary.AADHAARNo) {
        $("#SanctionUploadEsign").modal("show");
        $("#SanctionUploadEsign").css("z-index", "1050");
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "This document can not be uploaded because AADHAAR NO is not Added.",
          ...this.configSuccess,
        });
      }
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "This document can not be uploaded because email id is not find.",
        ...this.configSuccess,
      });
    }
  }
  OnCloseSanctionModal() {
    $("#SanctionUploadEsign").modal("hide");
    this.selectedEsignSanctionFile = "";
  }
  OnCloseAgreementModal() {
    $("#agreementUploadEsign").modal("hide");
    this.selectedEsignFile = "";
  }

  checkStatusForEsign() {
    this._QuickLoanService
      .DigioEsignStatusCheck({
        UploadId: this.loanSummary.Digio_Esign_UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe(
        (response: any) => {
          console.log("File uploaded successfully!", response);

          if (response.length > 0 && response[0].CODE >= 0) {
            if (response[0].MSG == "completed") {
              this.loanSummary.Digio_Esign_Status = "completed";
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Agreement E-Signed Succesfully.",
                ...this.configSuccess,
              });
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Agreement E-Sign Request Sent On Mail.",
                ...this.configSuccess,
              });
            }
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        (error) => {
          console.error("Error uploading file:", error);
        }
      );
  }
  checkStatusForEsignSanction() {
    this._QuickLoanService
      .DigioEsignStatusCheck({
        UploadId: this.loanSummary.Digio_Esign_Sanction_UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe(
        (response: any) => {
          console.log("File uploaded successfully!", response);

          if (response.length > 0 && response[0].CODE >= 0) {
            if (response[0].MSG == "completed") {
              this.loanSummary.Digio_Esign_Sanction_Status = "completed";
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Sanction Letter E-Signed Succesfully.",
                ...this.configSuccess,
              });
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Sanction Letter E-Sign Request Sent On Mail.",
                ...this.configSuccess,
              });
            }
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        (error) => {
          console.error("Error uploading file:", error);
        }
      );
  }

  downloadESign() {
    this._QuickLoanService
      .DigioEsignDownload({
        UploadId: this.loanSummary.Digio_Esign_UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        this.blobToBase64Async(res);
        this.saveFile(
          res,
          "LoanAgreement_" +
          this.loanSummary.ApplicationNo +
          "_" +
          this.loanSummary.Customer +
          ".pdf"
        );
      });
  }
  downloadESignSanction() {
    this._QuickLoanService
      .DigioEsignDownload({
        UploadId: this.loanSummary.Digio_Esign_Sanction_UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        this.blobToBase64Async(res);
        this.saveFile(
          res,
          "LoanSanction_" +
          this.loanSummary.ApplicationNo +
          "_" +
          this.loanSummary.Customer +
          ".pdf"
        );
      });
  }
  blobToBase64Async(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      let $this = this;
      fileReader.onerror = (e) => reject(fileReader.error);

      fileReader.onload = function () {
        $this.dataUrl = fileReader.result.toString().split(";base64,").pop();

        return;
      };
      if (blob) {
        fileReader.readAsDataURL(blob);
      }
    });
  }

  saveFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  InitiateEVideoKYC() {
    this._QuickLoanService
      .DigioVideoKycRequest({
        EmailId: this.loanSummary.Customer_Email,
        CustomerName: this.loanSummary.Customer,
        LoanId: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe(
        (response: any) => {
          if (response.length > 0 && response[0].CODE >= 0) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: " E-Video Kyc Requested Successfully!!",
              ...this.configSuccess,
            });
            this.loanSummary.Digio_Video_Status = "requested";
            this.loanSummary.Digio_Video_UploadId = response[0].MSG;
          } else {
            console.log("File uploaded successfully!", response);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        (error) => {
          console.error("Error For Request:", error);
        }
      );
  }
  checkStatusForEVideoKYC() {
    this._QuickLoanService
      .DigioVideoKycStatusCheck({
        UploadId: this.loanSummary.Digio_Video_UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe(
        (response: any) => {
          console.log("File uploaded successfully!", response);

          if (response.length > 0 && response[0].CODE >= 0) {
            if (response[0].MSG == "approved") {
              this.loanSummary.Digio_Video_Status = "approved";
              this.loanSummary.Digio_Video_FileId = response[0].R_No;
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Video KYC Approved Succesfully!!",
                ...this.configSuccess,
              });
            } else if (response[0].MSG == "approval_pending") {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Approval Pending",
                ...this.configSuccess,
              });
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Video KYC Request Sent On Mail.",
                ...this.configSuccess,
              });
            }
          } else {
            console.log("File uploaded successfully!", response);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        (error) => {
          console.error("Error uploading file:", error);
        }
      );
  }
  downloadEVideoKYC() {
    this._QuickLoanService
      .DigioVideoKycDownload({
        UploadId: this.loanSummary.Digio_Video_FileId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        this.blobToBase64Async(res);
        this.saveFile(
          res,
          "Video KYC_" +
          this.loanSummary.ApplicationNo +
          "_" +
          this.loanSummary.Customer +
          ".webm"
        );
      });
  }
  CancelForEsignSanction() {
    this._QuickLoanService
      .DigioEsignStatusCheck({
        UploadId: this.loanSummary.Digio_Esign_Sanction_UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe(
        (response: any) => {
          console.log("File uploaded successfully!", response);

          if (response.length > 0) {
            if (response[0].MSG == "completed") {
              this.loanSummary.Digio_Esign_Sanction_Status = "completed";
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Sanction Letter E-Signed Succesfully.",
                ...this.configSuccess,
              });
            } else {
              this._QuickLoanService
                .DigioEsignCancel({
                  UploadId: this.loanSummary.Digio_Esign_Sanction_UploadId,
                  LoanId: this.loanSummary.LoanId,
                })
                .subscribe((res) => {
                  if (res[0].MSG == "expired")
                    this.loanSummary.Digio_Esign_Sanction_Status = "";
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: "Sanction Letter E-Signed Canceled.",
                    ...this.configSuccess,
                  });
                });
            }
          }
        },
        (error) => {
          console.error("Error uploading file:", error);
        }
      );
  }

  Get_TemplateDetails(Id: any, templateName?: string) {
    this.loading = true;
    this.GetSanctionConditions();
    console.log("Loan Id for Template Details", templateName);
    this.MasterService.Get_Template_Details({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((res: any) => {
      this.loading = false;
      this.applicationDetails = res.Item1[0];
      console.log("Response Details Application ", res);
      this.Tcoborrower1Details = res.Item2[0];
      this.Tcoborrower2Details = res.Item2[1];
      this.Tguaranter1Details = res.Item3[0];
      this.Tguaranter2Details = res.Item3[1];
      this.TChargesBalance = res.Item4;
      this.TChargesDeduction = res.Item6;
      this.TsanctionLoanAmountObj = res.Item5[0];

      this.showSpinner = true;
      this.MasterService.Get_Template_Data({
        Id: Id,
        ProductId: this.applicationDetails.ProductId,
      }).subscribe(
        (res) => {
          console.log("resresresresresresresLOG", res[0].TemplateData);

          this.loading = false;
          this.templateDataLetter = res[0].TemplateData;
          this.selectedSanctionTemplateName = templateName;
          console.log("Template Data", this.selectedSanctionTemplateName);
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Application_No\]/g,
            this.applicationDetails.Application_No == null
              ? ""
              : this.applicationDetails.Application_No
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[APR\]/g,
            this.applicationDetails.APR == null
              ? ""
              : this.applicationDetails.APR
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_Date\]/g,
            this.applicationDetails.Sanction_Date == null
              ? ""
              : this.applicationDetails.Sanction_Date
          );
        this.templateDataLetter = this.templateDataLetter.replace(
              /\[Vehicle_Manufacture\]/g,
              this.applicationDetails.Vehicle_Manufacture == null
                ? ""
                : this.applicationDetails.Vehicle_Manufacture
            );
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[Vehicle_Type\]/g,
              this.applicationDetails.Vehicle_Type == null
                ? ""
                : this.applicationDetails.Vehicle_Type
            );
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[DPD\]/g,
              this.applicationDetails.DPD == null
                ? ""
                : this.applicationDetails.DPD
            );
             this.templateDataLetter = this.templateDataLetter.replace(
              /\[Last_Receipt_Date\]/g,
              this.applicationDetails.Last_Receipt_Date == null
                ? ""
                : this.applicationDetails.Last_Receipt_Date
            );
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[Installment_Received\]/g,
              this.applicationDetails.Installment_Received == null
                ? ""
                : this.applicationDetails.Installment_Received
            );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Source_Type\]/g,
            this.applicationDetails.SourceType == null
              ? ""
              : this.applicationDetails.SourceType
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Source_Name\]/g,
            this.applicationDetails.SourceName == null
              ? ""
              : this.applicationDetails.SourceName
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Branch_Name\]/g,
            this.applicationDetails.BranchName == null
              ? ""
              : this.applicationDetails.BranchName
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Property_Owner_Name\]/g,
            this.applicationDetails.Property_Owner_Name == null
              ? ""
              : this.applicationDetails.Property_Owner_Name
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Loan_No\]/g,
            this.applicationDetails.Loan_No == null
              ? ""
              : this.applicationDetails.Loan_No
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Name\]/g,
            this.applicationDetails.Customer_Name == null
              ? ""
              : this.applicationDetails.Customer_Name.toUpperCase()
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Father_Name\]/g,
            this.applicationDetails.Father_Name == null
              ? ""
              : this.applicationDetails.Father_Name.toUpperCase()
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Address\]/g,
            this.applicationDetails.Customer_Address == null
              ? ""
              : this.applicationDetails.Customer_Address.toUpperCase()
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_PhoneNo\]/g,
            this.applicationDetails.Customer_PhoneNo == null
              ? ""
              : this.applicationDetails.Customer_PhoneNo
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Loan_Product\]/g,
            this.applicationDetails.Loan_Product == null
              ? ""
              : this.applicationDetails.Loan_Product
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Loan_Amount\]/g,
            this.applicationDetails.Loan_Amount == null
              ? ""
              : this.applicationDetails.Loan_Amount
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Overdue_Installment_No\]/g,
            this.applicationDetails.OverDUE_EMI == null
              ? ""
              : this.applicationDetails.OverDUE_EMI
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Margin_Amount\]/g,
            this.applicationDetails.Margin_Amount == null
              ? ""
              : this.applicationDetails.Margin_Amount
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Tenure_Month\]/g,
            this.applicationDetails.Tenure_Month == null
              ? ""
              : this.applicationDetails.Tenure_Month
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[No_Of_instalment\]/g,
            this.applicationDetails.No_Of_instalment == null
              ? ""
              : this.applicationDetails.No_Of_instalment
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[EMI_Amount\]/g,
            this.applicationDetails.EMI_Amount == null
              ? ""
              : this.applicationDetails.EMI_Amount
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[EMI_Advance\]/g,
            this.applicationDetails.EMI_Advance == null
              ? ""
              : this.applicationDetails.EMI_Advance
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[ROI\]/g,
            this.applicationDetails.ROI == null
              ? ""
              : this.applicationDetails.ROI
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[IRR\]/g,
            this.applicationDetails.IRR == null
              ? ""
              : this.applicationDetails.IRR
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Monthly_IRR\]/g,
            this.applicationDetails.Monthly_IRR == null
              ? ""
              : this.applicationDetails.Monthly_IRR
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Borrower_Age\]/g,
            this.applicationDetails.Borrower_Age == null
              ? ""
              : this.applicationDetails.Borrower_Age
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Date\]/g,
            this.applicationDetails.Date == null
              ? ""
              : this.applicationDetails.Date
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Date_Of_EMI\]/g,
            this.applicationDetails.Date_Of_EMI == null
              ? ""
              : this.applicationDetails.Date_Of_EMI
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Day_Of_EMI\]/g,
            this.applicationDetails.Day_Of_EMI == null
              ? ""
              : this.applicationDetails.Day_Of_EMI
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[EMI_Frequency\]/g,
            this.applicationDetails.EMI_Frequency == null
              ? ""
              : this.applicationDetails.EMI_Frequency
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Relation\]/g,
            this.applicationDetails.Customer_Relation == null
              ? ""
              : this.applicationDetails.Customer_Relation
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Tehsil\]/g,
            this.applicationDetails.Customer_Tehsil == null
              ? ""
              : this.applicationDetails.Customer_Tehsil
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_District\]/g,
            this.applicationDetails.Customer_District == null
              ? ""
              : this.applicationDetails.Customer_District
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_State\]/g,
            this.applicationDetails.Customer_State == null
              ? ""
              : this.applicationDetails.Customer_State
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Pin_Code\]/g,
            this.applicationDetails.Customer_Pin_Code == null
              ? ""
              : this.applicationDetails.Customer_Pin_Code
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Exposure_Amount\]/g,
            this.applicationDetails.Exposure_Amount == null
              ? ""
              : this.applicationDetails.Exposure_Amount
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Overdue_Amount\]/g,
            this.applicationDetails.Overdue_Amount == null
              ? ""
              : this.applicationDetails.Overdue_Amount
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[DisbursementAmount\]/g,
            this.applicationDetails.DisbursementAmount == null
              ? ""
              : this.applicationDetails.DisbursementAmount
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[DealerName\]/g,
            this.applicationDetails.DealerName == null
              ? ""
              : this.applicationDetails.DealerName
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[VehicleModel\]/g,
            this.applicationDetails.Vehicle_Model == null
              ? ""
              : this.applicationDetails.Vehicle_Model
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[SalesExecutive\]/g,
            this.applicationDetails.SalesExecutive == null
              ? ""
              : this.applicationDetails.SalesExecutive
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[AssetsValue\]/g,
            this.applicationDetails.Application_AssetCost == null
              ? ""
              : this.applicationDetails.Application_AssetCost
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[LTV\]/g,
            this.applicationDetails.LTV == null
              ? ""
              : this.applicationDetails.LTV
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[LoanDate\]/g,
            this.applicationDetails.Loan_Date == null
              ? ""
              : this.applicationDetails.Loan_Date
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[CloseDate\]/g,
            this.applicationDetails.LoanCloseDate == null
              ? ""
              : this.applicationDetails.LoanCloseDate
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Total_Deduction\]/g,
            this.applicationDetails.Total_Deduction == null
              ? ""
              : this.applicationDetails.Total_Deduction
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Expiry_Date\]/g,
            this.applicationDetails.Expiry_Date == null
              ? ""
              : this.applicationDetails.Expiry_Date
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Nach_Bank\]/g,
            this.applicationDetails.Customer_Nach_Bank == null
              ? ""
              : this.applicationDetails.Customer_Nach_Bank
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Loan_Purpose\]/g,
            this.applicationDetails.Loan_Purpose == null
              ? ""
              : this.applicationDetails.Loan_Purpose
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Loan_Amount_InWord\]/g,
            this.applicationDetails.Loan_Amount_InWord == null
              ? ""
              : this.applicationDetails.Loan_Amount_InWord
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Property_Address\]/g,
            this.applicationDetails.Property_Address == null
              ? ""
              : this.applicationDetails.Property_Address
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Type_of_Property\]/g,
            this.applicationDetails.Type_of_Property == null
              ? ""
              : this.applicationDetails.Type_of_Property
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Nature_of_Property\]/g,
            this.applicationDetails.Nature_of_Property == null
              ? ""
              : this.applicationDetails.Nature_of_Property
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Ownership_Type\]/g,
            this.applicationDetails.Ownership_Type == null
              ? ""
              : this.applicationDetails.Ownership_Type
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Ownership_Document\]/g,
            this.applicationDetails.Ownership_Document == null
              ? ""
              : this.applicationDetails.Ownership_Document
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Unit_of_Measurement\]/g,
            this.applicationDetails.Unit_of_Measurement == null
              ? ""
              : this.applicationDetails.Unit_of_Measurement
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Total_Area\]/g,
            this.applicationDetails.Total_Area == null
              ? ""
              : this.applicationDetails.Total_Area
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Constructed_Area\]/g,
            this.applicationDetails.Constructed_Area == null
              ? ""
              : this.applicationDetails.Constructed_Area
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Engine_No\]/g,
            this.applicationDetails.Engine_No == null
              ? ""
              : this.applicationDetails.Engine_No
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Chassis_No\]/g,
            this.applicationDetails.Chassis_No == null
              ? ""
              : this.applicationDetails.Chassis_No
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Vehicle_Registation_No\]/g,
            this.applicationDetails.Vehicle_Registation_No == null
              ? ""
              : this.applicationDetails.Vehicle_Registation_No
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Identification_1\]/g,
            this.applicationDetails.Identification_1 == null
              ? ""
              : this.applicationDetails.Identification_1
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Identification_2\]/g,
            this.applicationDetails.Identification_2 == null
              ? ""
              : this.applicationDetails.Identification_2
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_Email\]/g,
            this.applicationDetails.Customer_Email == null
              ? ""
              : this.applicationDetails.Customer_Email
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Customer_PanNo\]/g,
            this.applicationDetails.Customer_PanNo == null
              ? ""
              : this.applicationDetails.Customer_PanNo
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Name1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_Name"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Relation1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_Relation"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Address1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_Address"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_PhoneNo1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_PhoneNo"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Tehsil1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_Tehsil"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_District1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_District"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_State1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_State"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Pin_Code1\]/g,
            this.Tcoborrower1Details
              ? this.Tcoborrower1Details["Customer_Pin_Code"]
              : ""
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Name2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_Name"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Relation2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_Relation"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Address2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_Address"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_PhoneNo2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_PhoneNo"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Tehsil2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_Tehsil"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_District2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_District"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_State2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_State"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[COBorrower_Pin_Code2\]/g,
            this.Tcoborrower2Details
              ? this.Tcoborrower2Details["Customer_Pin_Code"]
              : ""
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Name1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_Name"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Relation1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_Relation"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Address1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_Address"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_PhoneNo1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_PhoneNo"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Tehsil1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_Tehsil"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_District1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_District"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_State1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_State"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Pin_Code1\]/g,
            this.Tguaranter1Details
              ? this.Tguaranter1Details["Customer_Pin_Code"]
              : ""
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Name2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_Name"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Relation2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_Relation"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Address2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_Address"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_PhoneNo2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_PhoneNo"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Tehsil2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_Tehsil"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_District2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_District"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_State2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_State"]
              : ""
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Guarantor_Pin_Code2\]/g,
            this.Tguaranter2Details
              ? this.Tguaranter2Details["Customer_Pin_Code"]
              : ""
          );
          if (this.SanctionConditionsData.length > 0) {
            var prtSanction = document.getElementById("SanctionPrint");
            console.log("prtSanctionprtSanction", prtSanction.innerHTML);
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[Senction_Conditions\]/g,
              prtSanction.innerHTML
            );
          } else {
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[Senction_Conditions\]/g,
              ""
            );
          }
          if (this.LODDataDetail.length > 0) {
            var prtLODPrint = document.getElementById("LODPrint");
            console.log("prtLODPrint", prtLODPrint.innerHTML);
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[LOD\]/g,
              prtLODPrint.innerHTML
            );
          } else {
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[LOD\]/g,
              ""
            );
          }

          if (this.TsanctionLoanAmountObj) {
            var prtsanctionDetailPrint = document.getElementById(
              "sanctionDetailPrint"
            );
            console.log(
              "prtsanctionDetailPrint",
              prtsanctionDetailPrint.innerHTML
            );
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[Sanction_Detail\]/g,
              prtsanctionDetailPrint.innerHTML
            );
          } else {
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[Sanction_Detail\]/g,
              ""
            );
          }

          if (this.applicationDetails) {
            var sanctionDetailPrintKFS = document.getElementById(
              "sanctionDetailPrintKFS"
            );
            console.log(
              "sanctionDetailPrintKFS",
              sanctionDetailPrintKFS.innerHTML
            );
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[KFS_Detail\]/g,
              sanctionDetailPrintKFS.innerHTML
            );
          } else {
            this.templateDataLetter = this.templateDataLetter.replace(
              /\[KFS_Detail\]/g,
              ""
            );
          }

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_Loan_Amount\]/g,
            this.TsanctionLoanAmountObj?.sanction_LoanAmount == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_LoanAmount
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_Loan_Amount_InWord\]/g,
            this.TsanctionLoanAmountObj?.sanction_LoanAmount_InWord == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_LoanAmount_InWord
          );

          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_Loan_Date\]/g,
            this.TsanctionLoanAmountObj?.RepaymentDate == null
              ? ""
              : this.TsanctionLoanAmountObj?.RepaymentDate
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_EMI_Amount\]/g,
            this.TsanctionLoanAmountObj?.sanction_EMI_Amount == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_EMI_Amount
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_IRR\]/g,
            this.TsanctionLoanAmountObj?.sanction_IRR == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_IRR
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_No_of_Installment\]/g,
            this.TsanctionLoanAmountObj?.sanction_No_Of_Installment == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_No_Of_Installment
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_LoanTenure\]/g,
            this.TsanctionLoanAmountObj?.sanction_LoanTenure == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_LoanTenure
          );
          this.templateDataLetter = this.templateDataLetter.replace(
            /\[Sanction_ROI\]/g,
            this.TsanctionLoanAmountObj?.sanction_ROI == null
              ? ""
              : this.TsanctionLoanAmountObj?.sanction_ROI
          );
          console.log("content1111", this.templateDataLetter);

          if (this.TChargesBalance?.length > 0) {
            this.TChargesBalance.forEach((value) => {
              const escaped = this.escapeRegExp(value.Charges_Head);
              const pattern = new RegExp(escaped, "g");

              this.templateDataLetter = this.templateDataLetter.replace(
                pattern,
                value.Balance || ""
              );
            });
          }
          if (this.TChargesDeduction && this.TChargesDeduction.length > 0) {
            this.TChargesDeduction.forEach((value, index) => {
              const escaped = this.escapeRegExp(value.Charges_Head);
              const pattern = new RegExp(escaped, "g");

              this.templateDataLetter = this.templateDataLetter.replace(
                pattern,
                value.Balance || ""
              );
            });
          }

          this.contentTemplate = this.sanitizer.bypassSecurityTrustHtml(
            this.templateDataLetter
          );
          // setTimeout(() => {
          this.generatePdfAndAttach();
          // }, 100);
        },
        (error) => {
          this.showSpinner = false;
          console.error("Error fetching template data:", error);
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Error fetching template data: " + (error.message || error),
            ...this.configSuccess,
          });
        }
      );
    });
  }

  selectSanctionTemplate(template: any) {
    this.selectedSanctionTemplateName =
      template.Template_Name ||
      template.TemplateName ||
      this.selectedSanctionTemplateName;
    this.selectedSanctionTemplateId = template.Id;
  }

  async generatePdfAndAttach() {
    this.showSpinner = true;
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: "Generating PDF, please wait...",
      ...this.configSuccess,
    });

    await new Promise((r) => setTimeout(r, 50));

    const cleanHtml = this.cleanHtmlForPdf(this.templateDataLetter);
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = `<div class="pdf-container">${cleanHtml}</div>`;
    tempDiv.style.boxSizing = "border-box";
    tempDiv.style.width = "190mm";
    const style = document.createElement("style");
    style.innerHTML = `
    html, body { margin: 0; padding: 0; box-sizing: border-box; }
    .pdf-container { width: 190mm; max-width: 190mm; margin: 0 auto; box-sizing: border-box; overflow: visible; }
    table { width: 100%; border-collapse: collapse; margin: 10px 0px; table-layout: fixed; word-break: break-word; }
    th, td { border: 1px solid #000; padding: 8px; text-align: left; word-break: break-word; overflow-wrap: break-word; }
    img { max-width: 100%; height: auto; }
    .MsoNormal { margin: 0; padding: 0; }
    p { margin: 5px 0px; }
    u { text-decoration: underline; }
    b, strong { font-weight: bold; }
  `;
    tempDiv.insertBefore(style, tempDiv.firstChild);

    document.body.appendChild(tempDiv);

    const options = {
      margin: 10,
      filename: this.getPdfFileName(),
      image: { type: "jpeg", quality: 0.9 },
      html2canvas: {
        scale: 1.2,
        useCORS: true,
        logging: false,
        letterRendering: true,
        allowTaint: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"],
        before: ".page-break",
      },
    };

    try {
      await new Promise<void>((r) => requestAnimationFrame(() => r()));
      const pdf = await html2pdf()
        .from(tempDiv)
        .set(options)
        .toPdf()
        .get("pdf");
      const blob = pdf.output("blob");
      this.previewPdf(blob);
      this.prepareForEsign(blob);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "PDF generated successfully! Ready for e-sign.",
        ...this.configSuccess,
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Error generating PDF: " + (error.message || error),
        ...this.configSuccess,
      });
    } finally {
      try {
        document.body.removeChild(tempDiv);
      } catch (e) { }
      this.showSpinner = false;
    }
  }
  async generatePdfFromHtml(html: string) {
    this.showSpinner = true;
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: "Generating PDF, please wait...",
      ...this.configSuccess,
    });

    await new Promise((r) => setTimeout(r, 50));

    const options = {
      margin: 10,
      filename: this.getPdfFileName(),
      image: { type: "jpeg", quality: 0.9 },
      html2canvas: {
        scale: 1.2,
        useCORS: true,
        logging: false,
        letterRendering: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    };

    const tempElement = document.createElement("div");
    tempElement.style.position = "absolute";
    tempElement.style.left = "-9999px";
    tempElement.style.boxSizing = "border-box";
    tempElement.style.width = "190mm";
    tempElement.innerHTML = `<div class="pdf-container">${html}</div>`;

    const previewStyle = document.createElement("style");
    previewStyle.innerHTML = `
      html, body { margin: 0; padding: 0; box-sizing: border-box; }
      .pdf-container { width: 190mm; max-width: 190mm; margin: 0 auto; box-sizing: border-box; overflow: visible; }
      table { width: 100%; border-collapse: collapse; table-layout: fixed; word-break: break-word; }
      th, td { border: 1px solid #000; padding: 8px; word-break: break-word; overflow-wrap: break-word; }
      img { max-width: 100%; height: auto; }
    `;
    tempElement.insertBefore(previewStyle, tempElement.firstChild);

    document.body.appendChild(tempElement);

    try {
      await new Promise<void>((r) => requestAnimationFrame(() => r()));
      const pdf = await html2pdf()
        .from(tempElement)
        .set(options)
        .toPdf()
        .get("pdf");
      const blob = pdf.output("blob");
      document.body.removeChild(tempElement);
      this.prepareForEsign(blob);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "PDF generated successfully! Ready for e-sign.",
        ...this.configSuccess,
      });
    } catch (error) {
      document.body.removeChild(tempElement);
      console.error("PDF generation error:", error);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Error generating PDF: " + (error.message || error),
        ...this.configSuccess,
      });
    } finally {
      this.showSpinner = false;
    }
  }
  previewPdf(blob: Blob) {
    const blobUrl = URL.createObjectURL(blob);

    const newWindow = window.open(blobUrl, "_blank");

    if (!newWindow) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Popup blocked! PDF generated. You can download it.",
        ...this.configSuccess,
      });
    }

    this.pdfBlob = blob;
    this.pdfBlobUrl = blobUrl;
  }

  prepareForEsign(blob: Blob) {
    this.showSpinner = true;

    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.toString().split(",")[1];

      const pdfFile = new File([blob], this.getPdfFileName(), {
        type: "application/pdf",
      });

      this.fileChangeListener([pdfFile]);

      this.showSpinner = false;

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "PDF generated successfully! You can now upload for e-sign.",
        ...this.configSuccess,
      });
    };

    reader.onerror = (error) => {
      this.showSpinner = false;
      console.error("Error converting PDF to base64:", error);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Error preparing PDF for e-sign.",
        ...this.configSuccess,
      });
    };

    reader.readAsDataURL(blob);
  }

  // Build a sanitized base name for the PDF using the selected template name and application number
  private getPdfBaseName(): string {
    const rawName = (
      this.selectedSanctionTemplateName || "SanctionLetter"
    ).toString();
    // remove spaces and non-word characters for a clean file base name
    const sanitized = rawName.replace(/\s+/g, "").replace(/[^\w\-]/g, "");
    const appNo =
      this.loanSummary && this.loanSummary.ApplicationNo
        ? `_${this.loanSummary.ApplicationNo}`
        : "";
    return `${sanitized}${appNo}`.replace(/_$/, "");
  }

  private getPdfFileName(): string {
    const base = this.getPdfBaseName();
    return `${base || "SanctionLetter"}.pdf`;
  }

  escapeRegExp(str: string) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  // Add this function right after the existing OnESignAgreement() function
  // Look for this line in your component (around line 2720-2730):
  OnESignAgreement() {
    // ... existing code ...
  }

  // Add the new function right after it:
  OnESignGeneratedPDF() {
    if (!this.pdfBlob) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No PDF generated. Please generate PDF first.",
        ...this.configSuccess,
      });
      return;
    }

    // Check if customer data is available
    if (
      !this.dataSourceCustomerDetail ||
      this.dataSourceCustomerDetail.length === 0
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Customer details are not available. Please refresh the page.",
        ...this.configSuccess,
      });
      return;
    }

    // Check if e-sign coordinates are available
    if (!this.loanSummary?.DigioEsignCoordinates) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "E-Sign coordinates configuration is not available. Please contact administrator.",
        ...this.configSuccess,
      });
      return;
    }

    // Check if customerList and adharList are available
    if (!this.customerList || !this.adharList) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Customer signing information is not available. Please refresh the page.",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;

    // Prepare signers data
    let Idedifire1 = "0",
      Idedifire2 = "1",
      Idedifire3 = "2",
      Idedifire4 = "3";

    for (let i = 0; i < this.dataSourceCustomerDetail.length; i++) {
      if (i == 0) {
        Idedifire1 =
          this.dataSourceCustomerDetail[i].Customer_Email == null ?
            this.dataSourceCustomerDetail[i].PhoneNo?.toString() :
            this.dataSourceCustomerDetail[i].Customer_Email.toString() || "0";
      }
      if (i == 1) {
        Idedifire2 =
          this.dataSourceCustomerDetail[i].Customer_Email == null ?
            this.dataSourceCustomerDetail[i].PhoneNo?.toString() :
            this.dataSourceCustomerDetail[i].Customer_Email.toString() || "1";
      }
      if (i == 2) {
        Idedifire3 =
          this.dataSourceCustomerDetail[i].Customer_Email == null ?
            this.dataSourceCustomerDetail[i].PhoneNo?.toString() :
            this.dataSourceCustomerDetail[i].Customer_Email.toString() || "2";
      }
      if (i == 3) {
        Idedifire4 =
          this.dataSourceCustomerDetail[i].Customer_Email == null ?
            this.dataSourceCustomerDetail[i].PhoneNo?.toString() :
            this.dataSourceCustomerDetail[i].Customer_Email.toString() || "3";
      }
    }

    // Convert blob to base64 directly
    const reader = new FileReader();

    reader.onload = () => {
      const base64Data = reader.result.toString().split(",")[1];

      // Safely handle sign coordinates replacement
      let signCoordinates = this.loanSummary.DigioEsignCoordinates || "";

      // Only replace if we have valid coordinates and identifiers
      if (signCoordinates) {
        signCoordinates = signCoordinates.replace(/Idedifire1/g, Idedifire1);
        signCoordinates = signCoordinates.replace(/Idedifire2/g, Idedifire2);
        signCoordinates = signCoordinates.replace(/Idedifire3/g, Idedifire3);
        signCoordinates = signCoordinates.replace(/Idedifire4/g, Idedifire4);
      }

      // Validate sign coordinates after replacement
      if ((!signCoordinates || signCoordinates.trim() === "") && this.loanSummary.DigioEsigndisplay_on_page !== "All") {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Sign coordinates configuration is incomplete.",
          ...this.configSuccess,
        });
        return;
      }

      let request = "";
      try {
        if (this.loanSummary.IsReasonSendEsign) {
          request =
            "{" +
            '"signers": ' +
            this.customerList +
            "," +
            '"sign_coordinates":' +
            signCoordinates +
            "," +
            '"signature_verification": ' +
            this.adharList +
            ', "expire_in_days": 3, "generate_access_token": true, "display_on_page": "' +
            (this.loanSummary.DigioEsigndisplay_on_page != '' ? this.loanSummary.DigioEsigndisplay_on_page : "custom") + '", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
        } else {
          request =
            "{" +
            '"signers": ' +
            this.customerList +
            "," +
            '"sign_coordinates": ' +
            JSON.stringify(signCoordinates) +
            "," +
            '"signature_verification": ' +
            this.adharList +
            ', "expire_in_days": 3, "generate_access_token": true, "display_on_page": ' +
            (this.loanSummary.DigioEsigndisplay_on_page != '' ? this.loanSummary.DigioEsigndisplay_on_page : "custom") + '", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
        }
      } catch (error) {
        this.showSpinner = false;
        console.error("Error creating request JSON:", error);
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Error preparing e-sign request data.",
          ...this.configSuccess,
        });
        return;
      }
      console.log("E-Sign Request JSON:", this.loanSummary.LoanId);

      this._QuickLoanService
        .digioEsignRequest({
          base64String: base64Data,
          fileName: this.getPdfFileName(),
          text: request,
          LoanId: this.loanSummary.LoanId,
          LoginUserId: this.currentUser.userId,
          Type: "Agreement",
        })
        .subscribe(
          (response: any) => {
            this.showSpinner = false;
            if (response.length > 0 && response[0].CODE >= 0) {
              console.log("File uploaded successfully!", response);

              console.log("inside:", this.loanSummary.LoanId);
              this.MasterService
                .SendEventBasedNotif({
                  LoanId: this.loanSummary.LoanId,
                  EventName: 'LoanApprovalAccept',
                  JSON: null,
                  IsCustomer: 1
                })
                .subscribe((response1) => {
                  if (response1[0].CODE == 0) {
                    this.snackBar.openFromComponent(SnackbarComponent, {
                      data: response1[0].MSG,
                      ...this.configSuccess,
                    });
                  }
                })

              if (this.loanSummary.IsIFrameOpen) {
                $("#row").text("0");
                $("#DIDNo").text(response[0].MSG);
                $("#phoneDetailJsonString").text(
                  JSON.stringify(this.dataSourceCustomerDetail)
                );
                this.digioCall();
              } else {
                this.GetCustomerDetails();
              }

              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "E-Sign request submitted successfully!",
                ...this.configSuccess,
              });
              this.OnCloseagreementEsignModel();
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0]?.MSG || "Unknown error occurred.",
                ...this.configSuccess,
              });
            }
          },
          (error) => {
            this.showSpinner = false;
            console.error("Error uploading file:", error);
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "Error submitting e-sign request.",
              ...this.configSuccess,
            });
          }
        );
    };

    reader.onerror = (error) => {
      this.showSpinner = false;
      console.error("Error converting PDF to base64:", error);
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Error preparing PDF for e-sign.",
        ...this.configSuccess,
      });
    };

    reader.readAsDataURL(this.pdfBlob);
  }

  isPDFReady(): boolean {
    return !!this.pdfBlob;
  }
  openESignAggrementModel() {
    console.log("loan summaryyyyyyy", this.loanSummary);
    this.selectedEsignFile = "";
    this.DocModel.DocName = "";
    this.DocModel.DocData = "";
    this.pdfBlobUrl = "";
    this.pdfBlob = null;

    this.MasterService.Get_Template_Type({
      Type: "sanctionletter",
      ProductId: parseInt(this.loanSummary.ProductId),
    }).subscribe((x: any[]) => {
      this.dropdownTemplateSanction = x;
    });
    this.MasterService.Get_Template_Type({
      Type: "AgreementLetter",
      ProductId: parseInt(this.loanSummary.ProductId),
    }).subscribe((x: any[]) => {
      this.dropdownTemplateAgreement = x;
    });
    if (this.loanSummary.AADHAARNo) {
      $("#agreementEsignModel").modal("show");
      $("#agreementEsignModel").css("z-index", "1050");
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "This document can not be uploaded because AADHAAR NO is not Added.",
        ...this.configSuccess,
      });
    }
  }
  OnCloseagreementEsignModel() {
    $("#agreementEsignModel").modal("hide");
  }
  // OnESignAgreement() {
  //   if (!this.selectedEsignFile) {
  //     this.snackBar.openFromComponent(SnackbarComponent, {
  //       data: "Please upload Letter.",
  //       ...this.configSuccess,
  //     });
  //   } else {
  //     var Idedifire1 = "0",
  //       Idedifire2 = "1",
  //       Idedifire3 = "2",
  //       Idedifire4 = "3",
  //       Idedifire5 = "4";

  //     for (let i = 0; i < this.dataSourceCustomerDetail.length; i++) {
  //       if (i == 0) {
  //         Idedifire1 = this.dataSourceCustomerDetail[i].PhoneNo.toString();
  //       }
  //       if (i == 1) {
  //         Idedifire2 = this.dataSourceCustomerDetail[i].PhoneNo.toString();
  //       }
  //       if (i == 2) {
  //         Idedifire3 = this.dataSourceCustomerDetail[i].PhoneNo.toString();
  //       }
  //       if (i == 3) {
  //         Idedifire4 = this.dataSourceCustomerDetail[i].PhoneNo.toString();
  //       }
  //     }
  //     var signCoordinates = this.loanSummary.DigioEsignCoordinates;
  //     signCoordinates = signCoordinates.replace("Idedifire1", Idedifire1);
  //     signCoordinates = signCoordinates.replace("Idedifire2", Idedifire2);
  //     signCoordinates = signCoordinates.replace("Idedifire3", Idedifire3);
  //     signCoordinates = signCoordinates.replace("Idedifire4", Idedifire4);

  //     var request = "";
  //     if (this.loanSummary.IsReasonSendEsign) {
  //       request =
  //         "{" +
  //         '"signers": ' +
  //         this.customerList +
  //         "," +
  //         '"sign_coordinates":' +
  //         signCoordinates +
  //         "," +
  //         '"signature_verification": ' +
  //         this.adharList +
  //         ', "expire_in_days": 3, "generate_access_token": true, "display_on_page": "custom", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
  //     } else {
  //       request =
  //         "{" +
  //         '"signers": ' +
  //         this.customerList +
  //         "," +
  //         '"sign_coordinates": ' +
  //         JSON.stringify(signCoordinates) +
  //         "," +
  //         '"signature_verification": ' +
  //         this.adharList +
  //         ', "expire_in_days": 3, "generate_access_token": true, "display_on_page": "custom", "send_sign_link": "true",  "customer_notification_mode": "ALL", "notify_signers": "true" } ';
  //     }
  //     if (!this.DocModel.DocData) {
  //       this.snackBar.openFromComponent(SnackbarComponent, {
  //         data: "PDF data is not ready. Please wait...",
  //         ...this.configSuccess,
  //       });
  //       return;
  //     }

  //     this._QuickLoanService
  //       .digioEsignRequest({
  //         base64String: this.DocModel.DocData,
  //         fileName: this.DocModel.DocName,
  //         text: request,
  //         LoanId: this.loanSummary.LoanId,
  //         LoginUserId: JSON.parse(sessionStorage.getItem("currentUser")).userId,
  //         Type: "Agreement",
  //       })
  //       .subscribe(
  //         (response: any) => {
  //           if (response.length > 0 && response[0].CODE >= 0) {
  //             console.log("File uploaded successfully!", response);

  //             if (this.loanSummary.IsIFrameOpen) {
  //               $("#row").text("0");
  //               $("#DIDNo").text(response[0].MSG);
  //               $("#phoneDetailJsonString").text(
  //                 JSON.stringify(this.dataSourceCustomerDetail)
  //               );

  //               this.digioCall();
  //             } else {
  //               this.GetCustomerDetails();
  //             }
  //           }
  //         },
  //         (error) => {
  //           console.error("Error uploading file:", error);
  //         }
  //       );

  //     this.OnCloseagreementEsignModel();
  //   }
  // }

  digioCall() {
    var phoneDetaillength = $("#totalCustomer").text();
    phoneDetaillength = Number(phoneDetaillength);
    console.log("phoneDetaillength: ", phoneDetaillength);
    const options = {
      environment: "sandbox",
      redirect: false,
      mode: "modal",
      callback: function (res) {
        console.log("Response is: ", res);
        if (res.message != "Signed Successfully") {
          $("#digio_doc_id").text(res.digio_doc_id);
          $("#RejectClick").click();
        } else {
          var row = $("#row").text();
          console.log("rowFinal: ", row);
          console.log("phoneDetaillengthFinal: ", phoneDetaillength);

          for (let i = Number(row) + 1; i < phoneDetaillength; i++) {
            $("#row").text(i);
            $("#digioCallClick").click();
          }

          $("#RefereshClick").click();
        }
      },
      theme: {
        primaryColor: "#1F002A",
        secondaryColor: "#444444",
        fontUrl: "<font URL>",
        fontFormat: "truetype",
        fontFamily: "NaviBody",
      },
    };
    var digio = new Digio(options);
    digio.init();
    var row = $("#row").text();
    var DIDNo = $("#DIDNo").text();
    var phoneDetailJsonString = JSON.parse($("#phoneDetailJsonString").text());

    digio.submit(DIDNo, phoneDetailJsonString[row].PhoneNo);
  }

  downloadESignAgreement(row) {
    this._QuickLoanService
      .DigioEsignDownload({
        UploadId: row.UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((res: any) => {
        this.blobToBase64Async(res);
        this.saveFile(
          res,
          "LoanAgreement_" +
          this.loanSummary.ApplicationNo +
          "_" +
          this.loanSummary.Customer +
          ".pdf"
        );
      });
  }
  checkStatusForEsignAgreement(row) {
    this._QuickLoanService
      .DigioEsignStatusCheck({
        UploadId: row.UploadId,
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe(
        (response: any) => {
          console.log("File uploaded successfully!", response);

          if (response.length > 0 && response[0].CODE >= 0) {
            if (response[0].MSG == "completed") {
              this.GetCustomerDetails();
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Agreement E-Signed Succesfully.",
                ...this.configSuccess,
              });
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Agreement E-Sign Request Sent On Mail.",
                ...this.configSuccess,
              });
            }
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        (error) => {
          console.error("Error uploading file:", error);
        }
      );
  }
  RejectData() {
    var digio_doc_id = $("#digio_doc_id").text();
    this._QuickLoanService
      .QuickLoan_DeleteEsign({
        Id: 0,
        LoginUserId: this.currentUser.userId,
        DocId: digio_doc_id,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.showSpinner = false;
          this.GetCustomerDetails();
        }
      });
  }
  viewPdfPreview() {
    if (this.pdfBlobUrl) {
      window.open(this.pdfBlobUrl, "_blank");
    }
  }

  useThisPdf() {
    if (this.pdfBlob) {
      const pdfFile = new File([this.pdfBlob], this.getPdfFileName(), {
        type: "application/pdf",
      });

      this.fileChangeListener([pdfFile]);

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "PDF selected for e-sign!",
        ...this.configSuccess,
      });
    }
  }
  showPdfPreviewModal(pdfBlob: Blob) {
    const blobUrl = URL.createObjectURL(pdfBlob);
    this.pdfBlobUrl = blobUrl;
    this.pdfBlob = pdfBlob;
    $("#pdfPreviewModal").modal("show");
    $("#pdfPreviewModal").css("z-index", "1050");
  }

  confirmPdfForEsign() {
    if (this.pdfBlob) {
      const pdfFile = new File([this.pdfBlob], this.getPdfFileName(), {
        type: "application/pdf",
      });

      this.fileChangeListener([pdfFile]);

      $("#pdfPreviewModal").modal("hide");

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "PDF selected for e-sign!",
        ...this.configSuccess,
      });
    }
  }
}
